import { i18n } from 'core/localization';

export function Sidebar(designer) {
	this.designer = designer;
	this.editorUi = designer.editorUi;

	this.graph = this.editorUi.createTemporaryGraph(this.editorUi.editor.graph.getStylesheet());
	this.graph.cellRenderer.antiAlias = false;
	this.graph.foldingEnabled = false;
	this.graph.designer = designer;

	document.body.appendChild(this.graph.container);
}

/**
 * Sets the default font size.
 */
Sidebar.prototype.collapsedImage = !mxClient.IS_SVG
	? IMAGE_PATH + '/collapsed.gif'
	: 'data:image/gif;base64,R0lGODlhDQANAIABAJmZmf///yH/C1hNUCBEYXRhWE1QPD94cGFja2V0IGJlZ2luPSLvu78iIGlkPSJXNU0wTXBDZWhpSHpyZVN6TlRjemtjOWQiPz4gPHg6eG1wbWV0YSB4bWxuczp4PSJhZG9iZTpuczptZXRhLyIgeDp4bXB0az0iQWRvYmUgWE1QIENvcmUgNS4wLWMwNjAgNjEuMTM0Nzc3LCAyMDEwLzAyLzEyLTE3OjMyOjAwICAgICAgICAiPiA8cmRmOlJERiB4bWxuczpyZGY9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkvMDIvMjItcmRmLXN5bnRheC1ucyMiPiA8cmRmOkRlc2NyaXB0aW9uIHJkZjphYm91dD0iIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtbG5zOnhtcE1NPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvbW0vIiB4bWxuczpzdFJlZj0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL3NUeXBlL1Jlc291cmNlUmVmIyIgeG1wOkNyZWF0b3JUb29sPSJBZG9iZSBQaG90b3Nob3AgQ1M1IE1hY2ludG9zaCIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDozNUQyRTJFNjZGNUYxMUU1QjZEOThCNDYxMDQ2MzNCQiIgeG1wTU06RG9jdW1lbnRJRD0ieG1wLmRpZDozNUQyRTJFNzZGNUYxMUU1QjZEOThCNDYxMDQ2MzNCQiI+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOjFERjc3MEUxNkY1RjExRTVCNkQ5OEI0NjEwNDYzM0JCIiBzdFJlZjpkb2N1bWVudElEPSJ4bXAuZGlkOjFERjc3MEUyNkY1RjExRTVCNkQ5OEI0NjEwNDYzM0JCIi8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+Af/+/fz7+vn49/b19PPy8fDv7u3s6+rp6Ofm5eTj4uHg397d3Nva2djX1tXU09LR0M/OzczLysnIx8bFxMPCwcC/vr28u7q5uLe2tbSzsrGwr66trKuqqainpqWko6KhoJ+enZybmpmYl5aVlJOSkZCPjo2Mi4qJiIeGhYSDgoGAf359fHt6eXh3dnV0c3JxcG9ubWxramloZ2ZlZGNiYWBfXl1cW1pZWFdWVVRTUlFQT05NTEtKSUhHRkVEQ0JBQD8+PTw7Ojk4NzY1NDMyMTAvLi0sKyopKCcmJSQjIiEgHx4dHBsaGRgXFhUUExIREA8ODQwLCgkIBwYFBAMCAQAAIfkEAQAAAQAsAAAAAA0ADQAAAhSMj6lrwAjcC1GyahV+dcZJgeIIFgA7';

/**
 * Sets the default font size.
 */
Sidebar.prototype.expandedImage = !mxClient.IS_SVG
	? IMAGE_PATH + '/expanded.gif'
	: 'data:image/gif;base64,R0lGODlhDQANAIABAJmZmf///yH/C1hNUCBEYXRhWE1QPD94cGFja2V0IGJlZ2luPSLvu78iIGlkPSJXNU0wTXBDZWhpSHpyZVN6TlRjemtjOWQiPz4gPHg6eG1wbWV0YSB4bWxuczp4PSJhZG9iZTpuczptZXRhLyIgeDp4bXB0az0iQWRvYmUgWE1QIENvcmUgNS4wLWMwNjAgNjEuMTM0Nzc3LCAyMDEwLzAyLzEyLTE3OjMyOjAwICAgICAgICAiPiA8cmRmOlJERiB4bWxuczpyZGY9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkvMDIvMjItcmRmLXN5bnRheC1ucyMiPiA8cmRmOkRlc2NyaXB0aW9uIHJkZjphYm91dD0iIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtbG5zOnhtcE1NPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvbW0vIiB4bWxuczpzdFJlZj0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL3NUeXBlL1Jlc291cmNlUmVmIyIgeG1wOkNyZWF0b3JUb29sPSJBZG9iZSBQaG90b3Nob3AgQ1M1IE1hY2ludG9zaCIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDoxREY3NzBERjZGNUYxMUU1QjZEOThCNDYxMDQ2MzNCQiIgeG1wTU06RG9jdW1lbnRJRD0ieG1wLmRpZDoxREY3NzBFMDZGNUYxMUU1QjZEOThCNDYxMDQ2MzNCQiI+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOjFERjc3MERENkY1RjExRTVCNkQ5OEI0NjEwNDYzM0JCIiBzdFJlZjpkb2N1bWVudElEPSJ4bXAuZGlkOjFERjc3MERFNkY1RjExRTVCNkQ5OEI0NjEwNDYzM0JCIi8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+Af/+/fz7+vn49/b19PPy8fDv7u3s6+rp6Ofm5eTj4uHg397d3Nva2djX1tXU09LR0M/OzczLysnIx8bFxMPCwcC/vr28u7q5uLe2tbSzsrGwr66trKuqqainpqWko6KhoJ+enZybmpmYl5aVlJOSkZCPjo2Mi4qJiIeGhYSDgoGAf359fHt6eXh3dnV0c3JxcG9ubWxramloZ2ZlZGNiYWBfXl1cW1pZWFdWVVRTUlFQT05NTEtKSUhHRkVEQ0JBQD8+PTw7Ojk4NzY1NDMyMTAvLi0sKyopKCcmJSQjIiEgHx4dHBsaGRgXFhUUExIREA8ODQwLCgkIBwYFBAMCAQAAIfkEAQAAAQAsAAAAAA0ADQAAAhGMj6nL3QAjVHIu6azbvPtWAAA7';

/**
 * Specifies the delay for the drop target icons. Default is 200 ms.
 */
Sidebar.prototype.dropTargetDelay = 200;

/**
 * Specifies the URL of the gear image.
 */
Sidebar.prototype.gearImage = STENCIL_PATH + '/clipart/Gear_128x128.png';

/**
 * Specifies the width of the thumbnails.
 */
Sidebar.prototype.thumbWidth = 60;

/**
 * Specifies the height of the thumbnails.
 */
Sidebar.prototype.thumbHeight = 60;

/**
 * Specifies the padding for the thumbnails. Default is 3.
 */
Sidebar.prototype.thumbPadding = document.documentMode >= 5 ? 0 : 1;

/**
 * Specifies the delay for the tooltip. Default is 2 px.
 */
Sidebar.prototype.thumbBorder = 2;

/**
 * Specifies if titles in the tooltips should be enabled.
 */
Sidebar.prototype.tooltipTitles = true;

/**
 * Specifies if stencil files should be loaded and added to the search index
 * when stencil palettes are added. If this is false then the stencil files
 * are lazy-loaded when the palette is shown.
 */
Sidebar.prototype.addStencilsToIndex = true;

/**
 * Specifies the width for clipart images. Default is 80.
 */
Sidebar.prototype.defaultImageWidth = 80;

/**
 * Specifies the height for clipart images. Default is 80.
 */
Sidebar.prototype.defaultImageHeight = 80;

Sidebar.prototype.tagIndex =
	'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';

/**
 * Overrides gear image URL.
 */
Sidebar.prototype.gearImage = GRAPH_IMAGE_PATH + '/clipart/Gear_128x128.png';

/**
 *
 */
Sidebar.prototype.signs = [
	'Animals',
	'Food',
	'Healthcare',
	'Nature',
	'People',
	'Safety',
	'Science',
	'Sports',
	'Tech',
	'Transportation',
	'Travel',
];

/**
 *
 */
Sidebar.prototype.ibm = [
	'Analytics',
	'Applications',
	'Blockchain',
	'Data',
	'DevOps',
	'Infrastructure',
	'Management',
	'Miscellaneous',
	'Security',
	'Social',
	'Users',
];

/**
 *
 */
Sidebar.prototype.gcp = [
	'Cards',
	'Big Data',
	'Compute',
	'Developer Tools',
	'Extras',
	'Identity and Security',
	'Machine Learning',
	'Management Tools',
	'Networking',
	'Storage Databases',
];
/**
 *
 */
Sidebar.prototype.rack = ['General', 'APC', 'Cisco', 'Dell', 'F5', 'HP', 'IBM', 'Oracle'];

/**
 *
 */
Sidebar.prototype.pids = [
	'Agitators',
	'Apparatus Elements',
	'Centrifuges',
	'Compressors',
	'Compressors ISO',
	'Crushers Grinding',
	'Driers',
	'Engines',
	'Feeders',
	'Filters',
	'Fittings',
	'Flow Sensors',
	'Heat Exchangers',
	'Instruments',
	'Misc',
	'Mixers',
	'Piping',
	'Pumps',
	'Pumps DIN',
	'Pumps ISO',
	'Separators',
	'Shaping Machines',
	'Valves',
	'Vessels',
];

/**
 *
 */
Sidebar.prototype.cisco = [
	'Buildings',
	'Computers and Peripherals',
	'Controllers and Modules',
	'Directors',
	'Hubs and Gateways',
	'Misc',
	'Modems and Phones',
	'People',
	'Routers',
	'Security',
	'Servers',
	'Storage',
	'Switches',
	'Wireless',
];

/**
 *
 */
Sidebar.prototype.sysml = [
	'Model Elements',
	'Blocks',
	'Ports and Flows',
	'Constraint Blocks',
	'Activities',
	'Interactions',
	'State Machines',
	'Use Cases',
	'Allocations',
	'Requirements',
	'Profiles',
	'Stereotypes',
];

/**
 *
 */
Sidebar.prototype.eip = [
	'Message Construction',
	'Message Routing',
	'Message Transformation',
	'Messaging Channels',
	'Messaging Endpoints',
	'Messaging Systems',
	'System Management',
];

/**
 *
 */
Sidebar.prototype.gmdl = [
	'Bottom Navigation',
	'Bottom Sheets',
	'Buttons',
	'Cards',
	'Chips',
	'Dialogs',
	'Dividers',
	'Grid Lists',
	'Icons',
	'Lists',
	'Menus',
	'Misc',
	'Pickers',
	'Selection Controls',
	'Sliders',
	'Steppers',
	'Tabs',
	'Text Fields',
];

/**
 *
 */
Sidebar.prototype.aws2 = [
	'Analytics',
	'Application Services',
	'Compute',
	'Database',
	'Developer Tools',
	'Enterprise Applications',
	'Game Development',
	'General',
	'Internet of Things',
	'Management Tools',
	'Mobile Services',
	'Networking',
	'On-Demand Workforce',
	'SDKs',
	'Security and Identity',
	'Storage and Content Delivery',
	'Groups',
];

/**
 *
 */
Sidebar.prototype.aws3 = [
	'Analytics',
	'Application Services',
	'Artificial Intelligence',
	'Business Productivity',
	'Compute',
	'Database',
	'Desktop and App Streaming',
	'Developer Tools',
	'Game Development',
	'General',
	'Groups',
	'Internet of Things',
	'Management Tools',
	'Messaging',
	'Migration',
	'Mobile Services',
	'Networking and Content Delivery',
	'On Demand Workforce',
	'SDKs',
	'Security Identity and Compliance',
	'Storage',
];

/**
 *
 */
Sidebar.prototype.office = [
	'Clouds',
	'Communications',
	'Concepts',
	'Databases',
	'Devices',
	'Security',
	'Servers',
	'Services',
	'Sites',
	'Users',
];

/**
 *
 */
Sidebar.prototype.veeam = ['2D', '3D'];

/**
 *
 */
Sidebar.prototype.archimate3 = [
	'Application',
	'Business',
	'Composite',
	'Implementation and Migration',
	'Motivation',
	'Physical',
	'Relationships',
	'Strategy',
	'Technology',
];

/**
 *
 */
Sidebar.prototype.electrical = [
	'LogicGates',
	'Resistors',
	'Capacitors',
	'Inductors',
	'SwitchesRelays',
	'Diodes',
	'Sources',
	'Transistors',
	'Misc',
	'Audio',
	'PlcLadder',
	'Abstract',
	'Optical',
	'VacuumTubes',
	'Waveforms',
	'Instruments',
	'RotMech',
	'Transmission',
];

Sidebar.prototype.initPalettes = function () {
	let imgDir = GRAPH_IMAGE_PATH;
	let dir = STENCIL_PATH;
	let signs = this.signs;
	let gcp = this.gcp;
	let rack = this.rack;
	let pids = this.pids;
	let cisco = this.cisco;
	let sysml = this.sysml;
	let eip = this.eip;
	let gmdl = this.gmdl;
	let office = this.office;
	let veeam = this.veeam;
	let archimate3 = this.archimate3;
	let electrical = this.electrical;
	this.palettes = [];

	this.addCeeviewPalette();
	this.addGeneralPalette();
	this.addMaterialIconsPalette();
	this.addGlyphiconsPalette();
	this.addMiscPalette();
	this.addAdvancedPalette();
	this.addUmlPalette();
	this.addErPalette();
	this.addBasicPalette();
	this.addFlowchartPalette();
	this.addNetworkPalette();
	this.addAzurePalette();
	this.addCitrixPalette();
	this.addMSCAEPalette();
	this.addBpmnPalette(dir);
	this.addAWS3Palette();
	this.addAWS3DPalette();
	this.addLeanMappingPalette();
	this.addIos7Palette();
	this.addIosPalette();
	this.addAndroidPalette();
	this.addMockupPalette();
	this.addElectricalPalette();
	this.addOfficePalette();
	this.addVeeamPalette();
	this.addIBMPalette();

	this.addArrows2Palette();

	this.addImagePalette(
		'computer',
		'Clipart / Computer',
		imgDir + '/clip_art/computers/',
		'_128x128.png',
		[
			'Antivirus',
			'Data_Filtering',
			'Database',
			'Database_Add',
			'Database_Minus',
			'Database_Move_Stack',
			'Database_Remove',
			'Fujitsu_Tablet',
			'Harddrive',
			'IBM_Tablet',
			'iMac',
			'iPad',
			'Laptop',
			'MacBook',
			'Mainframe',
			'Monitor',
			'Monitor_Tower',
			'Monitor_Tower_Behind',
			'Netbook',
			'Network',
			'Network_2',
			'Printer',
			'Printer_Commercial',
			'Secure_System',
			'Server',
			'Server_Rack',
			'Server_Rack_Empty',
			'Server_Rack_Partial',
			'Server_Tower',
			'Software',
			'Stylus',
			'Touch',
			'USB_Hub',
			'Virtual_Application',
			'Virtual_Machine',
			'Virus',
			'Workstation',
		],
		[
			'Antivirus',
			'Data Filtering',
			'Database',
			'Database Add',
			'Database Minus',
			'Database Move Stack',
			'Database Remove',
			'Fujitsu Tablet',
			'Harddrive',
			'IBMTablet',
			'iMac',
			'iPad',
			'Laptop',
			'MacBook',
			'Mainframe',
			'Monitor',
			'Monitor Tower',
			'Monitor Tower Behind',
			'Netbook',
			'Network',
			'Network 2',
			'Printer',
			'Printer Commercial',
			'Secure System',
			'Server',
			'Server Rack',
			'Server Rack Empty',
			'Server Rack Partial',
			'Server Tower',
			'Software',
			'Stylus',
			'Touch',
			'USB Hub',
			'Virtual Application',
			'Virtual Machine',
			'Virus',
			'Workstation',
		],
	);
	this.addImagePalette(
		'finance',
		'Clipart / Finance',
		imgDir + '/clip_art/finance/',
		'_128x128.png',
		[
			'Arrow_Down',
			'Arrow_Up',
			'Coins',
			'Credit_Card',
			'Dollar',
			'Graph',
			'Pie_Chart',
			'Piggy_Bank',
			'Safe',
			'Shopping_Cart',
			'Stock_Down',
			'Stock_Up',
		],
		[
			'Arrow Down',
			'Arrow Up',
			'Coins',
			'Credit Card',
			'Dollar',
			'Graph',
			'Pie Chart',
			'Piggy Bank',
			'Safe',
			'Shopping Basket',
			'Stock Down',
			'Stock Up',
		],
	);
	this.addImagePalette(
		'clipart',
		'Clipart / Various',
		imgDir + '/clip_art/general/',
		'_128x128.png',
		[
			'Battery_0',
			'Battery_100',
			'Battery_50',
			'Battery_75',
			'Battery_allstates',
			'Bluetooth',
			'Earth_globe',
			'Empty_Folder',
			'Full_Folder',
			'Gear',
			'Keys',
			'Lock',
			'Mouse_Pointer',
			'Plug',
			'Ships_Wheel',
			'Star',
			'Tire',
		],
		[
			'Battery 0%',
			'Battery 100%',
			'Battery 50%',
			'Battery 75%',
			'Battery',
			'Bluetooth',
			'Globe',
			'Empty Folder',
			'Full Folder',
			'Gear',
			'Keys',
			'Lock',
			'Mousepointer',
			'Plug',
			'Ships Wheel',
			'Star',
			'Tire',
		],
	);
	this.addImagePalette(
		'networking',
		'Clipart / Networking',
		imgDir + '/clip_art/networking/',
		'_128x128.png',
		[
			'Bridge',
			'Certificate',
			'Certificate_Off',
			'Cloud',
			'Cloud_Computer',
			'Cloud_Computer_Private',
			'Cloud_Rack',
			'Cloud_Rack_Private',
			'Cloud_Server',
			'Cloud_Server_Private',
			'Cloud_Storage',
			'Concentrator',
			'Email',
			'Firewall_02',
			'Firewall',
			'Firewall-page1',
			'Ip_Camera',
			'Modem',
			'power_distribution_unit',
			'Print_Server',
			'Print_Server_Wireless',
			'Repeater',
			'Router',
			'Router_Icon',
			'Switch',
			'UPS',
			'Wireless_Router',
			'Wireless_Router_N',
		],
		[
			'Bridge',
			'Certificate',
			'Certificate Off',
			'Cloud',
			'Cloud Computer',
			'Cloud Computer Private',
			'Cloud Rack',
			'Cloud Rack Private',
			'Cloud Server',
			'Cloud Server Private',
			'Cloud Storage',
			'Concentrator',
			'Email',
			'Firewall 1',
			'Firewall 2',
			'Firewall',
			'Camera',
			'Modem',
			'Power Distribution Unit',
			'Print Server',
			'Print Server Wireless',
			'Repeater',
			'Router',
			'Router Icon',
			'Switch',
			'UPS',
			'Wireless Router',
			'Wireless Router N',
		],
		{
			Wireless_Router: 'wireless router switch wap wifi access point wlan',
			Wireless_Router_N: 'wireless router switch wap wifi access point wlan',
			Router: 'router switch',
			Router_Icon: 'router switch',
		},
	);
	this.addImagePalette('people', 'Clipart / People', imgDir + '/clip_art/people/', '_128x128.png', [
		'Suit_Man',
		'Suit_Man_Black',
		'Suit_Man_Blue',
		'Suit_Man_Green',
		'Suit_Man_Green_Black',
		'Suit_Woman',
		'Suit_Woman_Black',
		'Suit_Woman_Blue',
		'Suit_Woman_Green',
		'Suit_Woman_Green_Black',
		'Construction_Worker_Man',
		'Construction_Worker_Man_Black',
		'Construction_Worker_Woman',
		'Construction_Worker_Woman_Black',
		'Doctor_Man',
		'Doctor_Man_Black',
		'Doctor_Woman',
		'Doctor_Woman_Black',
		'Farmer_Man',
		'Farmer_Man_Black',
		'Farmer_Woman',
		'Farmer_Woman_Black',
		'Nurse_Man',
		'Nurse_Man_Black',
		'Nurse_Woman',
		'Nurse_Woman_Black',
		'Military_Officer',
		'Military_Officer_Black',
		'Military_Officer_Woman',
		'Military_Officer_Woman_Black',
		'Pilot_Man',
		'Pilot_Man_Black',
		'Pilot_Woman',
		'Pilot_Woman_Black',
		'Scientist_Man',
		'Scientist_Man_Black',
		'Scientist_Woman',
		'Scientist_Woman_Black',
		'Security_Man',
		'Security_Man_Black',
		'Security_Woman',
		'Security_Woman_Black',
		'Tech_Man',
		'Tech_Man_Black',
		'Telesales_Man',
		'Telesales_Man_Black',
		'Telesales_Woman',
		'Telesales_Woman_Black',
		'Waiter',
		'Waiter_Black',
		'Waiter_Woman',
		'Waiter_Woman_Black',
		'Worker_Black',
		'Worker_Man',
		'Worker_Woman',
		'Worker_Woman_Black',
	]);
	this.addImagePalette(
		'telco',
		'Clipart / Telecommunication',
		imgDir + '/clip_art/telecommunication/',
		'_128x128.png',
		['BlackBerry', 'Cellphone', 'HTC_smartphone', 'iPhone', 'Palm_Treo', 'Signal_tower_off', 'Signal_tower_on'],
		['BlackBerry', 'Cellphone', 'HTC smartphone', 'iPhone', 'Palm Treo', 'Signaltower off', 'Signaltower on'],
	);

	for (let i = 0; i < signs.length; i++) {
		this.addStencilPalette(
			'signs' + signs[i],
			'Signs / ' + signs[i],
			dir + '/signs/' + signs[i].toLowerCase() + '.xml',
			';html=1;fillColor=#000000;strokeColor=none;verticalLabelPosition=bottom;verticalAlign=top;align=center;',
		);
	}

	for (let i = 0; i < gcp.length; i++) {
		if (gcp[i].toLowerCase() === 'cards') {
			this.addGoogleCloudPlatformCardsPalette();
		} else {
			this.addStencilPalette(
				'gcp' + gcp[i],
				'GCP / ' + gcp[i],
				dir + '/gcp/' + gcp[i].toLowerCase().replace(/ /g, '_') + '.xml',
				';html=1;fillColor=#4387FD;gradientColor=#4683EA;strokeColor=none;verticalLabelPosition=bottom;verticalAlign=top;align=center;',
			);
		}
	}

	for (let i = 0; i < rack.length; i++) {
		if (rack[i].toLowerCase() === 'general') {
			this.addRackGeneralPalette();
		} else if (rack[i].toLowerCase() === 'f5') {
			this.addRackF5Palette();
		} else {
			this.addStencilPalette(
				'rack' + rack[i],
				'Rack / ' + rack[i],
				dir + '/rack/' + rack[i].toLowerCase() + '.xml',
				';html=1;labelPosition=right;align=left;spacingLeft=15;dashed=0;shadow=0;fillColor=#ffffff;',
			);
		}
	}

	for (let i = 0; i < pids.length; i++) {
		if (pids[i] == 'Instruments') {
			this.addPidInstrumentsPalette();
		} else if (pids[i] == 'Misc') {
			this.addPidMiscPalette();
		} else if (pids[i] == 'Valves') {
			this.addPidValvesPalette();
		} else if (pids[i] == 'Compressors') {
			this.addPidCompressorsPalette();
		} else if (pids[i] == 'Engines') {
			this.addPidEnginesPalette();
		} else if (pids[i] == 'Filters') {
			this.addPidFiltersPalette();
		} else if (pids[i] == 'Flow Sensors') {
			this.addPidFlowSensorsPalette();
		} else if (pids[i] == 'Piping') {
			this.addPidPipingPalette();
		} else {
			this.addStencilPalette(
				'pid' + pids[i],
				'Proc. Eng. / ' + pids[i],
				dir + '/pid/' + pids[i].toLowerCase().replace(' ', '_') + '.xml',
				';html=1;align=center;' +
					mxConstants.STYLE_VERTICAL_LABEL_POSITION +
					'=bottom;' +
					mxConstants.STYLE_VERTICAL_ALIGN +
					'=top;dashed=0;',
			);
		}
	}

	for (let i = 0; i < sysml.length; i++) {
		if (sysml[i] == 'Model Elements') {
			this.addSysMLModelElementsPalette();
		} else if (sysml[i] == 'Blocks') {
			this.addSysMLBlocksPalette();
		} else if (sysml[i] == 'Ports and Flows') {
			this.addSysMLPortsAndFlowsPalette();
		} else if (sysml[i] == 'Constraint Blocks') {
			this.addSysMLConstraintBlocksPalette();
		} else if (sysml[i] == 'Activities') {
			this.addSysMLActivitiesPalette();
		} else if (sysml[i] == 'Interactions') {
			this.addSysMLInteractionsPalette();
		} else if (sysml[i] == 'State Machines') {
			this.addSysMLStateMachinesPalette();
		} else if (sysml[i] == 'Use Cases') {
			this.addSysMLUseCasesPalette();
		} else if (sysml[i] == 'Allocations') {
			this.addSysMLAllocationsPalette();
		} else if (sysml[i] == 'Requirements') {
			this.addSysMLRequirementsPalette();
		} else if (sysml[i] == 'Profiles') {
			this.addSysMLProfilesPalette();
		} else if (sysml[i] == 'Stereotypes') {
			this.addSysMLStereotypesPalette();
		}
	}

	for (let i = 0; i < eip.length; i++) {
		if (eip[i] == 'Message Construction') {
			this.addEipMessageConstructionPalette();
		} else if (eip[i] == 'Message Routing') {
			this.addEipMessageRoutingPalette();
		} else if (eip[i] == 'Message Transformation') {
			this.addEipMessageTransformationPalette();
		} else if (eip[i] == 'Messaging Channels') {
			this.addEipMessagingChannelsPalette();
		} else if (eip[i] == 'Messaging Endpoints') {
			this.addEipMessagingEndpointsPalette();
		} else if (eip[i] == 'Messaging Systems') {
			this.addEipMessagingSystemsPalette();
		} else if (eip[i] == 'System Management') {
			this.addEipSystemManagementPalette();
		}
	}

	for (let i = 0; i < cisco.length; i++) {
		this.addStencilPalette(
			'cisco' + cisco[i],
			'Cisco / ' + cisco[i],
			dir + '/cisco/' + cisco[i].toLowerCase().replace(/ /g, '_') + '.xml',
			';html=1;dashed=0;fillColor=#036897;strokeColor=#ffffff;strokeWidth=2;verticalLabelPosition=bottom;verticalAlign=top',
			null,
			null,
			1.6,
		);
	}

	this.addFloorplanPalette();
	this.addAtlassianPalette();
	this.addBootstrapPalette();

	for (let i = 0; i < gmdl.length; i++) {
		if (gmdl[i] == 'Bottom Navigation') {
			this.addGMDLBottomNavigationPalette();
		} else if (gmdl[i] == 'Bottom Sheets') {
			this.addGMDLBottomSheetsPalette();
		} else if (gmdl[i] == 'Buttons') {
			this.addGMDLButtonsPalette();
		} else if (gmdl[i] == 'Cards') {
			this.addGMDLCardsPalette();
		} else if (gmdl[i] == 'Chips') {
			this.addGMDLChipsPalette();
		} else if (gmdl[i] == 'Dialogs') {
			this.addGMDLDialogsPalette();
		} else if (gmdl[i] == 'Dividers') {
			this.addGMDLDividersPalette();
		} else if (gmdl[i] == 'Grid Lists') {
			this.addGMDLGridListsPalette();
		} else if (gmdl[i] == 'Icons') {
			this.addGMDLIconsPalette();
		} else if (gmdl[i] == 'Lists') {
			this.addGMDLListsPalette();
		} else if (gmdl[i] == 'Menus') {
			this.addGMDLMenusPalette();
		} else if (gmdl[i] == 'Misc') {
			this.addGMDLMiscPalette();
		} else if (gmdl[i] == 'Pickers') {
			this.addGMDLPickersPalette();
		} else if (gmdl[i] == 'Selection Controls') {
			this.addGMDLSelectionControlsPalette();
		} else if (gmdl[i] == 'Sliders') {
			this.addGMDLSlidersPalette();
		} else if (gmdl[i] == 'Steppers') {
			this.addGMDLSteppersPalette();
		} else if (gmdl[i] == 'Tabs') {
			this.addGMDLTabsPalette();
		} else if (gmdl[i] == 'Text Fields') {
			this.addGMDLTextFieldsPalette();
		}
	}

	this.addCabinetsPalette();
	this.addArchimate3Palette();
	this.addArchiMatePalette();
	this.addWebIconsPalette();
	this.addWebLogosPalette();
};

/**
 * Hides the current tooltip.
 */
Sidebar.prototype.addEntry = function (tags, fn) {
	//console.log(tags);
	fn.tags = tags;
	return fn;
	if (this.taglist != null && tags != null && tags.length > 0) {
		// Replaces special characters
		let tmp = tags
			.toLowerCase()
			.replace(/[\/\,\(\)]/g, ' ')
			.split(' ');

		let doAddEntry = mxUtils.bind(this, function (tag) {
			if (tag.length > 1) {
				let entry = this.taglist[tag];

				if (typeof entry !== 'object') {
					entry = { entries: [], dict: new mxDictionary() };
					this.taglist[tag] = entry;
				}

				// Ignores duplicates
				if (entry.dict.get(fn) == null) {
					entry.dict.put(fn, fn);
					entry.entries.push(fn);
				}
			}
		});

		for (let i = 0; i < tmp.length; i++) {
			doAddEntry(tmp[i]);

			// Adds additional entry with removed trailing numbers
			let normalized = tmp[i].replace(/\.*\d*$/, '');

			if (normalized != tmp[i]) {
				doAddEntry(normalized);
			}
		}
	}

	return fn;
};

/**
 * Adds shape search UI.
 */
Sidebar.prototype.filterTags = function (tags) {
	if (tags != null) {
		let arr = tags.split(' ');
		let result = [];
		let hash = {};

		// Ignores tags with leading numbers, strips trailing numbers
		for (let i = 0; i < arr.length; i++) {
			// Removes duplicates
			if (hash[arr[i]] == null) {
				hash[arr[i]] = '1';
				result.push(arr[i]);
			}
		}

		return result.join(' ');
	}

	return null;
};

/**
 * Adds the general palette to the sidebar.
 */
Sidebar.prototype.cloneCell = function (cell, value) {
	let clone = cell.clone();

	if (value != null) {
		clone.value = value;
	}

	return clone;
};

/**
 * Hides the current tooltip.
 */
Sidebar.prototype.addDataEntry = function (tags, width, height, title, data) {
	return this.addEntry(
		tags,
		mxUtils.bind(this, function () {
			return this.createVertexTemplateFromData(data, width, height, title);
		}),
	);
};

/**
 * Adds the general palette to the sidebar.
 */
Sidebar.prototype.addGeneralPalette = function (expand) {
	let lineTags = 'line lines connector connectors connection connections arrow arrows ';

	let fns = [
		this.createVertexTemplateEntry(
			'rounded=0;whiteSpace=wrap;html=1;',
			120,
			60,
			'',
			'Rectangle',
			null,
			null,
			'rect rectangle box',
		),
		this.createVertexTemplateEntry(
			'rounded=1;whiteSpace=wrap;html=1;',
			120,
			60,
			'',
			'Rounded Rectangle',
			null,
			null,
			'rounded rect rectangle box',
		),
		// Explicit strokecolor/fillcolor=none is a workaround to maintain transparent background regardless of current style
		this.createVertexTemplateEntry(
			'text;html=1;strokeColor=none;fillColor=none;align=center;verticalAlign=middle;whiteSpace=wrap;verticalLabelPosition=center;',
			40,
			20,
			'Text',
			'Text',
			null,
			null,
			'text textbox textarea label',
		),
		this.createVertexTemplateEntry(
			'text;html=1;strokeColor=none;fillColor=none;spacing=5;spacingTop=-20;whiteSpace=wrap;overflow=hidden;verticalLabelPosition=center;',
			190,
			120,
			'<h1>Heading</h1><p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>',
			'Textbox',
			null,
			null,
			'text textbox textarea',
		),
		this.createVertexTemplateEntry(
			'shape=ext;double=1;rounded=0;whiteSpace=wrap;html=1;',
			120,
			60,
			'',
			'Double Rectangle',
			null,
			null,
			'rect rectangle box double',
		),
		this.createVertexTemplateEntry(
			'shape=ext;double=1;rounded=1;whiteSpace=wrap;html=1;',
			120,
			60,
			'',
			'Double Rounded Rectangle',
			null,
			null,
			'rounded rect rectangle box double',
		),
		this.createVertexTemplateEntry(
			'ellipse;whiteSpace=wrap;html=1;',
			120,
			80,
			'',
			'Ellipse',
			null,
			null,
			'oval ellipse state',
		),
		this.createVertexTemplateEntry(
			'ellipse;shape=doubleEllipse;whiteSpace=wrap;html=1;',
			120,
			80,
			'',
			'Double Ellipse',
			null,
			null,
			'oval ellipse start end state double',
		),
		this.createVertexTemplateEntry('whiteSpace=wrap;html=1;aspect=fixed;', 80, 80, '', 'Square', null, null, 'square'),
		this.createVertexTemplateEntry(
			'shape=ext;double=1;whiteSpace=wrap;html=1;aspect=fixed;',
			80,
			80,
			'',
			'Double Square',
			null,
			null,
			'double square',
		),
		this.createVertexTemplateEntry(
			'ellipse;whiteSpace=wrap;html=1;aspect=fixed;',
			80,
			80,
			'',
			'Circle',
			null,
			null,
			'circle',
		),
		this.createVertexTemplateEntry(
			'ellipse;shape=doubleEllipse;whiteSpace=wrap;html=1;aspect=fixed;',
			80,
			80,
			'',
			'Double Circle',
			null,
			null,
			'double circle',
		),
		this.createVertexTemplateEntry(
			'shape=process;whiteSpace=wrap;html=1;',
			120,
			60,
			'',
			'Process',
			null,
			null,
			'process task',
		),
		this.createVertexTemplateEntry(
			'rhombus;whiteSpace=wrap;html=1;',
			80,
			80,
			'',
			'Diamond',
			null,
			null,
			'diamond rhombus if condition decision conditional question test',
		),
		this.createVertexTemplateEntry('shape=parallelogram;whiteSpace=wrap;html=1;', 120, 60, '', 'Parallelogram'),
		this.createVertexTemplateEntry(
			'shape=hexagon;perimeter=hexagonPerimeter;whiteSpace=wrap;html=1;',
			120,
			80,
			'',
			'Hexagon',
			null,
			null,
			'hexagon preparation',
		),
		this.createVertexTemplateEntry(
			'triangle;whiteSpace=wrap;html=1;',
			60,
			80,
			'',
			'Triangle',
			null,
			null,
			'triangle logic inverter buffer',
		),
		this.createVertexTemplateEntry(
			'shape=cylinder;whiteSpace=wrap;html=1;',
			60,
			80,
			'',
			'Cylinder',
			null,
			null,
			'cylinder data database',
		),
		this.createVertexTemplateEntry(
			'ellipse;shape=cloud;whiteSpace=wrap;html=1;',
			120,
			80,
			'',
			'Cloud',
			null,
			null,
			'cloud network',
		),
		this.createVertexTemplateEntry('shape=document;whiteSpace=wrap;html=1;', 120, 80, '', 'Document'),
		this.createVertexTemplateEntry('shape=internalStorage;whiteSpace=wrap;html=1;', 80, 80, '', 'Internal Storage'),
		this.createVertexTemplateEntry('shape=cube;whiteSpace=wrap;html=1;', 120, 80, '', 'Cube'),
		this.createVertexTemplateEntry('shape=step;whiteSpace=wrap;html=1;', 120, 80, '', 'Step'),
		this.createVertexTemplateEntry('shape=trapezoid;whiteSpace=wrap;html=1;', 120, 60, '', 'Trapezoid'),
		this.createVertexTemplateEntry('shape=tape;whiteSpace=wrap;html=1;', 120, 100, '', 'Tape'),
		this.createVertexTemplateEntry('shape=note;whiteSpace=wrap;html=1;', 80, 100, '', 'Note'),
		this.createVertexTemplateEntry('shape=card;whiteSpace=wrap;html=1;', 80, 100, '', 'Card'),
		this.createEdgeTemplateEntry(
			'endArrow=classic;html=1;',
			50,
			50,
			'',
			'Directional Connector',
			null,
			lineTags + 'directional directed',
		),
		this.createEdgeTemplateEntry(
			'endArrow=none;html=1;dashed=1;dashPattern=1 4;',
			50,
			50,
			'',
			'Dotted Line',
			null,
			lineTags + 'dotted undirected no',
		),
		this.createEdgeTemplateEntry(
			'endArrow=none;dashed=1;html=1;',
			50,
			50,
			'',
			'Dashed Line',
			null,
			lineTags + 'dashed undirected no',
		),
		this.createEdgeTemplateEntry(
			'endArrow=none;html=1;',
			50,
			50,
			'',
			'Line',
			null,
			lineTags + 'simple undirected plain blank no',
		),
		this.createEdgeTemplateEntry(
			'endArrow=classic;startArrow=classic;html=1;',
			50,
			50,
			'',
			'Bidirectional Connector',
			null,
			lineTags + 'bidirectional',
		),
	];

	this.addPaletteFunctions('general', mxResources.get('general'), expand != null ? expand : true, fns);
};

/**
 * Adds the general palette to the sidebar.
 */
Sidebar.prototype.addMiscPalette = function (expand) {
	let lineTags = 'line lines connector connectors connection connections arrow arrows ';

	let fns = [
		this.createVertexTemplateEntry(
			'text;strokeColor=none;fillColor=none;html=1;fontSize=24;fontStyle=1;verticalAlign=middle;align=center;',
			100,
			40,
			'Title',
			'Title',
			null,
			null,
			'text heading title',
		),
		this.createVertexTemplateEntry(
			'text;strokeColor=none;fillColor=none;html=1;whiteSpace=wrap;verticalAlign=middle;overflow=hidden;',
			100,
			80,
			'<ul><li>Value 1</li><li>Value 2</li><li>Value 3</li></ul>',
			'Unordered List',
		),
		this.createVertexTemplateEntry(
			'text;strokeColor=none;fillColor=none;html=1;whiteSpace=wrap;verticalAlign=middle;overflow=hidden;',
			100,
			80,
			'<ol><li>Value 1</li><li>Value 2</li><li>Value 3</li></ol>',
			'Ordered List',
		),
		this.createVertexTemplateEntry(
			'text;html=1;strokeColor=#c0c0c0;fillColor=#ffffff;overflow=fill;rounded=0;',
			280,
			160,
			'<table border="1" width="100%" height="100%" cellpadding="4" style="width:100%;height:100%;border-collapse:collapse;">' +
				'<tr style="background-color:#A7C942;color:#ffffff;border:1px solid #98bf21;"><th align="left">Title 1</th><th align="left">Title 2</th><th align="left">Title 3</th></tr>' +
				'<tr style="border:1px solid #98bf21;"><td>Value 1</td><td>Value 2</td><td>Value 3</td></tr>' +
				'<tr style="background-color:#EAF2D3;border:1px solid #98bf21;"><td>Value 4</td><td>Value 5</td><td>Value 6</td></tr>' +
				'<tr style="border:1px solid #98bf21;"><td>Value 7</td><td>Value 8</td><td>Value 9</td></tr>' +
				'<tr style="background-color:#EAF2D3;border:1px solid #98bf21;"><td>Value 10</td><td>Value 11</td><td>Value 12</td></tr></table>',
			'Table 1',
		),
		this.createVertexTemplateEntry(
			'text;html=1;strokeColor=#c0c0c0;fillColor=none;overflow=fill;',
			180,
			140,
			'<table border="0" width="100%" height="100%" style="width:100%;height:100%;border-collapse:collapse;">' +
				'<tr><td align="center">Value 1</td><td align="center">Value 2</td><td align="center">Value 3</td></tr>' +
				'<tr><td align="center">Value 4</td><td align="center">Value 5</td><td align="center">Value 6</td></tr>' +
				'<tr><td align="center">Value 7</td><td align="center">Value 8</td><td align="center">Value 9</td></tr></table>',
			'Table 2',
		),
		this.createVertexTemplateEntry(
			'text;html=1;strokeColor=none;fillColor=none;overflow=fill;',
			180,
			140,
			'<table border="1" width="100%" height="100%" style="width:100%;height:100%;border-collapse:collapse;">' +
				'<tr><td align="center">Value 1</td><td align="center">Value 2</td><td align="center">Value 3</td></tr>' +
				'<tr><td align="center">Value 4</td><td align="center">Value 5</td><td align="center">Value 6</td></tr>' +
				'<tr><td align="center">Value 7</td><td align="center">Value 8</td><td align="center">Value 9</td></tr></table>',
			'Table 3',
		),
		this.createVertexTemplateEntry(
			'text;html=1;strokeColor=none;fillColor=none;overflow=fill;',
			160,
			140,
			'<table border="1" width="100%" height="100%" cellpadding="4" style="width:100%;height:100%;border-collapse:collapse;">' +
				'<tr><th align="center"><b>Title</b></th></tr>' +
				'<tr><td align="center">Section 1.1\nSection 1.2\nSection 1.3</td></tr>' +
				'<tr><td align="center">Section 2.1\nSection 2.2\nSection 2.3</td></tr></table>',
			'Table 4',
		),
		this.addEntry(
			'link hyperlink',
			mxUtils.bind(this, function () {
				let cell = new mxCell(
					'Link',
					new mxGeometry(0, 0, 60, 40),
					'text;html=1;strokeColor=none;fillColor=none;whiteSpace=wrap;align=center;verticalAlign=middle;fontColor=#0000EE;fontStyle=4;',
				);
				cell.vertex = true;
				this.graph.setLinkForCell(cell, 'https://www.draw.io');

				return this.createVertexTemplateFromCells([cell], cell.geometry.width, cell.geometry.height, 'Link');
			}),
		),
		this.addEntry(
			'timestamp date time text label',
			mxUtils.bind(this, function () {
				let cell = new mxCell(
					'%date{ddd mmm dd yyyy HH:MM:ss}%',
					new mxGeometry(0, 0, 160, 20),
					'text;html=1;strokeColor=none;fillColor=none;align=center;verticalAlign=middle;whiteSpace=wrap;overflow=hidden;',
				);
				cell.vertex = true;
				this.graph.setAttributeForCell(cell, 'placeholders', '1');

				return this.createVertexTemplateFromCells([cell], cell.geometry.width, cell.geometry.height, 'Timestamp');
			}),
		),
		this.addEntry(
			'variable placeholder metadata hello world text label',
			mxUtils.bind(this, function () {
				let cell = new mxCell(
					'%name% Text',
					new mxGeometry(0, 0, 80, 20),
					'text;html=1;strokeColor=none;fillColor=none;align=center;verticalAlign=middle;whiteSpace=wrap;overflow=hidden;',
				);
				cell.vertex = true;
				this.graph.setAttributeForCell(cell, 'placeholders', '1');
				this.graph.setAttributeForCell(cell, 'name', 'Variable');

				return this.createVertexTemplateFromCells([cell], cell.geometry.width, cell.geometry.height, 'Variable');
			}),
		),
		this.createVertexTemplateEntry(
			'shape=umlActor;verticalLabelPosition=bottom;labelBackgroundColor=#ffffff;verticalAlign=top;html=1;',
			30,
			60,
			'Actor',
			'Actor',
			false,
			null,
			'user person human stickman',
		),
		this.createVertexTemplateEntry(
			'html=1;whiteSpace=wrap;comic=1;strokeWidth=2;fontFamily=Comic Sans MS;fontStyle=1;',
			120,
			60,
			'RECTANGLE',
			'Comic Rectangle',
			true,
			null,
			'comic rectangle rect box text retro',
		),
		this.createVertexTemplateEntry(
			'rhombus;html=1;align=center;whiteSpace=wrap;comic=1;strokeWidth=2;fontFamily=Comic Sans MS;fontStyle=1;',
			100,
			100,
			'DIAMOND',
			'Comic Diamond',
			true,
			null,
			'comic diamond rhombus if condition decision conditional question test retro',
		),
		this.createEdgeTemplateEntry(
			'rounded=0;comic=1;strokeWidth=2;endArrow=blockThin;html=1;fontFamily=Comic Sans MS;fontStyle=1;',
			50,
			50,
			'',
			'Comic Arrow',
		),
		this.createVertexTemplateEntry(
			'html=1;whiteSpace=wrap;aspect=fixed;shape=isoRectangle;',
			150,
			90,
			'',
			'Isometric Square',
			true,
			null,
			'rectangle rect box iso isometric',
		),
		this.createVertexTemplateEntry(
			'html=1;whiteSpace=wrap;aspect=fixed;shape=isoCube;',
			90,
			100,
			'',
			'Isometric Cube',
			true,
			null,
			'cube box iso isometric',
		),
		this.createEdgeTemplateEntry('edgeStyle=isometricEdgeStyle;endArrow=none;html=1;', 50, 100, '', 'Isometric Edge 1'),
		this.createEdgeTemplateEntry(
			'edgeStyle=isometricEdgeStyle;endArrow=none;html=1;elbow=vertical;',
			50,
			100,
			'',
			'Isometric Edge 2',
		),
		this.createVertexTemplateEntry('line;strokeWidth=2;html=1;', 160, 10, '', 'Horizontal Line'),
		this.createVertexTemplateEntry('line;strokeWidth=2;direction=south;html=1;', 10, 160, '', 'Vertical Line'),
		this.createVertexTemplateEntry(
			'line;strokeWidth=4;html=1;perimeter=backbonePerimeter;points=[];outlineConnect=0;',
			160,
			10,
			'',
			'Horizontal Backbone',
			false,
			null,
			'backbone bus network',
		),
		this.createVertexTemplateEntry(
			'line;strokeWidth=4;direction=south;html=1;perimeter=backbonePerimeter;points=[];outlineConnect=0;',
			10,
			160,
			'',
			'Vertical Backbone',
			false,
			null,
			'backbone bus network',
		),
		this.createVertexTemplateEntry(
			'shape=curlyBracket;whiteSpace=wrap;html=1;rounded=1;',
			20,
			120,
			'',
			'Curly Bracket',
		),
		this.createVertexTemplateEntry(
			'shape=crossbar;whiteSpace=wrap;html=1;rounded=1;',
			120,
			20,
			'',
			'Crossbar',
			false,
			null,
			'crossbar distance measure dimension unit',
		),
		this.createVertexTemplateEntry(
			'shape=image;html=1;verticalLabelPosition=bottom;labelBackgroundColor=#ffffff;verticalAlign=top;imageAspect=1;aspect=fixed;image=' +
				this.gearImage,
			52,
			61,
			'',
			'Image (Fixed Aspect)',
			false,
			null,
			'fixed image icon symbol',
		),
		this.createVertexTemplateEntry(
			'shape=image;html=1;verticalLabelPosition=bottom;labelBackgroundColor=#ffffff;verticalAlign=top;imageAspect=0;image=' +
				this.gearImage,
			50,
			60,
			'',
			'Image (Variable Aspect)',
			false,
			null,
			'strechted image icon symbol',
		),
		this.createVertexTemplateEntry(
			'icon;html=1;image=' + this.gearImage,
			60,
			60,
			'Icon',
			'Icon',
			false,
			null,
			'icon image symbol',
		),
		this.createVertexTemplateEntry(
			'label;whiteSpace=wrap;html=1;image=' + this.gearImage,
			140,
			60,
			'Label',
			'Label 1',
			null,
			null,
			'label image icon symbol',
		),
		this.createVertexTemplateEntry(
			'label;whiteSpace=wrap;html=1;align=center;verticalAlign=bottom;spacingLeft=0;spacingBottom=4;imageAlign=center;imageVerticalAlign=top;image=' +
				this.gearImage,
			120,
			80,
			'Label',
			'Label 2',
			null,
			null,
			'label image icon symbol',
		),
		this.createEdgeTemplateEntry(
			'shape=flexArrow;endArrow=classic;html=1;fillColor=#ffffff;',
			50,
			50,
			'',
			'Directional Arrow',
			null,
			lineTags + 'directional directed',
		),
		this.createEdgeTemplateEntry(
			'shape=flexArrow;endArrow=classic;startArrow=classic;html=1;fillColor=#ffffff;',
			50,
			50,
			'',
			'Bidirectional Arrow',
			null,
			lineTags + 'bidirectional',
		),
		this.createEdgeTemplateEntry(
			'edgeStyle=segmentEdgeStyle;endArrow=classic;html=1;',
			50,
			50,
			'',
			'Manual Line',
			null,
			lineTags + 'manual',
		),
		this.createEdgeTemplateEntry(
			'edgeStyle=elbowEdgeStyle;elbow=horizontal;endArrow=classic;html=1;',
			50,
			50,
			'',
			'Horizontal Elbow',
			null,
			lineTags + 'elbow horizontal',
		),
		this.createEdgeTemplateEntry(
			'edgeStyle=elbowEdgeStyle;elbow=vertical;endArrow=classic;html=1;',
			50,
			50,
			'',
			'Vertical Elbow',
			null,
			lineTags + 'elbow vertical',
		),
		this.addEntry(
			'curve',
			mxUtils.bind(this, function () {
				let cell = new mxCell('', new mxGeometry(0, 0, 50, 50), 'curved=1;endArrow=classic;html=1;');
				cell.geometry.setTerminalPoint(new mxPoint(0, 50), true);
				cell.geometry.setTerminalPoint(new mxPoint(50, 0), false);
				cell.geometry.points = [new mxPoint(50, 50), new mxPoint(0, 0)];
				cell.geometry.relative = true;
				cell.edge = true;

				return this.createEdgeTemplateFromCells(
					[cell],
					cell.geometry.width,
					cell.geometry.height,
					'Bidirectional Curve',
				);
			}),
		),
		this.createEdgeTemplateEntry('shape=link;html=1;', 50, 50, '', 'Link', null, lineTags + 'link'),
	];

	this.addPaletteFunctions('misc', mxResources.get('misc'), expand != null ? expand : true, fns);
};
/**
 * Adds the container palette to the sidebar.
 */
Sidebar.prototype.addAdvancedPalette = function (expand) {
	this.addPaletteFunctions(
		'advanced',
		mxResources.get('advanced'),
		expand != null ? expand : false,
		this.createAdvancedShapes(),
	);
};

/**
 * Adds the container palette to the sidebar.
 */
Sidebar.prototype.createAdvancedShapes = function () {
	// Avoids having to bind all functions to "this"
	let sb = this;

	// Reusable cells
	let field = new mxCell(
		'List Item',
		new mxGeometry(0, 0, 60, 26),
		'text;strokeColor=none;fillColor=none;align=left;verticalAlign=top;spacingLeft=4;spacingRight=4;overflow=hidden;rotatable=0;points=[[0,0.5],[1,0.5]];portConstraint=eastwest;',
	);
	field.vertex = true;

	return [
		this.createVertexTemplateEntry('shape=xor;whiteSpace=wrap;html=1;', 60, 80, '', 'Or', null, null, 'logic or'),
		this.createVertexTemplateEntry('shape=or;whiteSpace=wrap;html=1;', 60, 80, '', 'And', null, null, 'logic and'),
		this.createVertexTemplateEntry('shape=dataStorage;whiteSpace=wrap;html=1;', 100, 80, '', 'Data Storage'),
		this.createVertexTemplateEntry(
			'shape=tapeData;whiteSpace=wrap;html=1;perimeter=ellipsePerimeter;',
			80,
			80,
			'',
			'Tape Data',
		),
		this.createVertexTemplateEntry('shape=manualInput;whiteSpace=wrap;html=1;', 80, 80, '', 'Manual Input'),
		this.createVertexTemplateEntry('shape=loopLimit;whiteSpace=wrap;html=1;', 100, 80, '', 'Loop Limit'),
		this.createVertexTemplateEntry('shape=offPageConnector;whiteSpace=wrap;html=1;', 80, 80, '', 'Off Page Connector'),
		this.createVertexTemplateEntry('shape=delay;whiteSpace=wrap;html=1;', 80, 40, '', 'Delay'),
		this.createVertexTemplateEntry('shape=display;whiteSpace=wrap;html=1;', 80, 40, '', 'Display'),
		this.createVertexTemplateEntry(
			'shape=singleArrow;direction=west;whiteSpace=wrap;html=1;',
			100,
			60,
			'',
			'Arrow Left',
		),
		this.createVertexTemplateEntry('shape=singleArrow;whiteSpace=wrap;html=1;', 100, 60, '', 'Arrow Right'),
		this.createVertexTemplateEntry(
			'shape=singleArrow;direction=north;whiteSpace=wrap;html=1;',
			60,
			100,
			'',
			'Arrow Up',
		),
		this.createVertexTemplateEntry(
			'shape=singleArrow;direction=south;whiteSpace=wrap;html=1;',
			60,
			100,
			'',
			'Arrow Down',
		),
		this.createVertexTemplateEntry('shape=doubleArrow;whiteSpace=wrap;html=1;', 100, 60, '', 'Double Arrow'),
		this.createVertexTemplateEntry(
			'shape=doubleArrow;direction=south;whiteSpace=wrap;html=1;',
			60,
			100,
			'',
			'Double Arrow Vertical',
			null,
			null,
			'double arrow',
		),
		this.createVertexTemplateEntry(
			'shape=actor;whiteSpace=wrap;html=1;',
			40,
			60,
			'',
			'User',
			null,
			null,
			'user person human',
		),
		this.createVertexTemplateEntry('shape=cross;whiteSpace=wrap;html=1;', 80, 80, '', 'Cross'),
		this.createVertexTemplateEntry('shape=corner;whiteSpace=wrap;html=1;', 80, 80, '', 'Corner'),
		this.createVertexTemplateEntry('shape=tee;whiteSpace=wrap;html=1;', 80, 80, '', 'Tee'),
		this.createVertexTemplateEntry(
			'shape=datastore;whiteSpace=wrap;html=1;',
			60,
			60,
			'',
			'Data Store',
			null,
			null,
			'data store cylinder database',
		),
		this.createVertexTemplateEntry(
			'shape=orEllipse;perimeter=ellipsePerimeter;whiteSpace=wrap;html=1;',
			80,
			80,
			'',
			'Or',
			null,
			null,
			'or circle oval ellipse',
		),
		this.createVertexTemplateEntry(
			'shape=sumEllipse;perimeter=ellipsePerimeter;whiteSpace=wrap;html=1;',
			80,
			80,
			'',
			'Sum',
			null,
			null,
			'sum circle oval ellipse',
		),
		this.createVertexTemplateEntry(
			'shape=lineEllipse;perimeter=ellipsePerimeter;whiteSpace=wrap;html=1;',
			80,
			80,
			'',
			'Ellipse with horizontal divider',
			null,
			null,
			'circle oval ellipse',
		),
		this.createVertexTemplateEntry(
			'shape=lineEllipse;line=vertical;perimeter=ellipsePerimeter;whiteSpace=wrap;html=1;',
			80,
			80,
			'',
			'Ellipse with vertical divider',
			null,
			null,
			'circle oval ellipse',
		),
		this.createVertexTemplateEntry(
			'shape=sortShape;perimeter=rhombusPerimeter;whiteSpace=wrap;html=1;',
			80,
			80,
			'',
			'Sort',
			null,
			null,
			'sort',
		),
		this.createVertexTemplateEntry(
			'shape=collate;whiteSpace=wrap;html=1;',
			80,
			80,
			'',
			'Collate',
			null,
			null,
			'collate',
		),
		this.createVertexTemplateEntry(
			'shape=switch;whiteSpace=wrap;html=1;',
			60,
			60,
			'',
			'Switch',
			null,
			null,
			'switch router',
		),
		this.createVertexTemplateEntry(
			'shape=dimension;whiteSpace=wrap;html=1;align=center;points=[];verticalAlign=bottom;spacingBottom=-5;labelBackgroundColor=#ffffff',
			100,
			40,
			'Label',
			'Horizontal Dimension',
			null,
			null,
			'horizontal dimension measure distance unit',
		),
		this.createVertexTemplateEntry(
			'shape=dimension;direction=north;whiteSpace=wrap;html=1;align=right;points=[];verticalAlign=middle;labelBackgroundColor=#ffffff',
			40,
			100,
			'Label',
			'Vertical Dimension',
			null,
			null,
			'vertical dimension measure distance unit',
		),
		this.createVertexTemplateEntry(
			'swimlane;',
			200,
			200,
			'Container',
			'Container',
			null,
			null,
			'container swimlane lane pool',
		),
		this.addEntry('list', function () {
			let cell = new mxCell(
				'List',
				new mxGeometry(0, 0, 140, 110),
				'swimlane;fontStyle=0;childLayout=stackLayout;horizontal=1;startSize=26;fillColor=none;horizontalStack=0;resizeParent=1;resizeLast=0;collapsible=1;marginBottom=0;swimlaneFillColor=#ffffff;',
			);
			cell.vertex = true;
			cell.insert(sb.cloneCell(field, 'Item 1'));
			cell.insert(sb.cloneCell(field, 'Item 2'));
			cell.insert(sb.cloneCell(field, 'Item 3'));

			return sb.createVertexTemplateFromCells([cell], cell.geometry.width, cell.geometry.height, 'List');
		}),
		this.addEntry('list item entry value', function () {
			return sb.createVertexTemplateFromCells(
				[sb.cloneCell(field, 'List Item')],
				field.geometry.width,
				field.geometry.height,
				'List Item',
			);
		}),
	];
};

/**
 * Adds the general palette to the sidebar.
 */
Sidebar.prototype.addUmlPalette = function (expand) {
	// Avoids having to bind all functions to "this"
	let sb = this;

	// Reusable cells
	let field = new mxCell(
		'+ field: type',
		new mxGeometry(0, 0, 100, 26),
		'text;strokeColor=none;fillColor=none;align=left;verticalAlign=top;spacingLeft=4;spacingRight=4;overflow=hidden;rotatable=0;points=[[0,0.5],[1,0.5]];portConstraint=eastwest;',
	);
	field.vertex = true;

	let divider = new mxCell(
		'',
		new mxGeometry(0, 0, 40, 8),
		'line;strokeWidth=1;fillColor=none;align=left;verticalAlign=middle;spacingTop=-1;spacingLeft=3;spacingRight=3;rotatable=0;labelPosition=right;points=[];portConstraint=eastwest;',
	);
	divider.vertex = true;

	// Default tags
	let dt = 'uml static class ';

	let fns = [
		this.createVertexTemplateEntry('html=1;', 110, 50, 'Object', 'Object', null, null, dt + 'object instance'),
		this.createVertexTemplateEntry(
			'html=1;',
			110,
			50,
			'&laquo;interface&raquo;<br><b>Name</b>',
			'Interface',
			null,
			null,
			dt + 'interface object instance annotated annotation',
		),
		this.addEntry(dt + 'object instance', function () {
			let cell = new mxCell(
				'Classname',
				new mxGeometry(0, 0, 160, 90),
				'swimlane;fontStyle=1;align=center;verticalAlign=top;childLayout=stackLayout;horizontal=1;startSize=26;horizontalStack=0;resizeParent=1;resizeLast=0;collapsible=1;marginBottom=0;swimlaneFillColor=#ffffff;',
			);
			cell.vertex = true;
			cell.insert(field.clone());
			cell.insert(divider.clone());
			cell.insert(sb.cloneCell(field, '+ method(type): type'));

			return sb.createVertexTemplateFromCells([cell], cell.geometry.width, cell.geometry.height, 'Class');
		}),
		this.addEntry(dt + 'section subsection', function () {
			let cell = new mxCell(
				'Classname',
				new mxGeometry(0, 0, 140, 110),
				'swimlane;fontStyle=0;childLayout=stackLayout;horizontal=1;startSize=26;fillColor=none;horizontalStack=0;resizeParent=1;resizeLast=0;collapsible=1;marginBottom=0;swimlaneFillColor=#ffffff;',
			);
			cell.vertex = true;
			cell.insert(field.clone());
			cell.insert(field.clone());
			cell.insert(field.clone());

			return sb.createVertexTemplateFromCells([cell], cell.geometry.width, cell.geometry.height, 'Class 2');
		}),
		this.addEntry(dt + 'item member method function variable field attribute label', function () {
			return sb.createVertexTemplateFromCells(
				[sb.cloneCell(field, '+ item: attribute')],
				field.geometry.width,
				field.geometry.height,
				'Item 1',
			);
		}),
		this.addEntry(dt + 'item member method function variable field attribute label', function () {
			let cell = new mxCell(
				'item: attribute',
				new mxGeometry(0, 0, 120, field.geometry.height),
				'label;fontStyle=0;strokeColor=none;fillColor=none;align=left;verticalAlign=top;overflow=hidden;' +
					'spacingLeft=28;spacingRight=4;rotatable=0;points=[[0,0.5],[1,0.5]];portConstraint=eastwest;imageWidth=16;imageHeight=16;image=' +
					sb.gearImage,
			);
			cell.vertex = true;

			return sb.createVertexTemplateFromCells([cell], cell.geometry.width, cell.geometry.height, 'Item 2');
		}),
		this.addEntry(dt + 'divider hline line separator', function () {
			return sb.createVertexTemplateFromCells(
				[divider.clone()],
				divider.geometry.width,
				divider.geometry.height,
				'Divider',
			);
		}),
		this.addEntry(dt + 'spacer space gap separator', function () {
			let cell = new mxCell(
				'',
				new mxGeometry(0, 0, 20, 14),
				'text;strokeColor=none;fillColor=none;align=left;verticalAlign=middle;spacingTop=-1;spacingLeft=4;spacingRight=4;rotatable=0;labelPosition=right;points=[];portConstraint=eastwest;',
			);
			cell.vertex = true;

			return sb.createVertexTemplateFromCells([cell.clone()], cell.geometry.width, cell.geometry.height, 'Spacer');
		}),
		this.createVertexTemplateEntry(
			'text;align=center;fontStyle=1;verticalAlign=middle;spacingLeft=3;spacingRight=3;strokeColor=none;rotatable=0;points=[[0,0.5],[1,0.5]];portConstraint=eastwest;',
			80,
			26,
			'Title',
			'Title',
			null,
			null,
			dt + 'title label',
		),
		this.addEntry(dt + 'component', function () {
			let cell = new mxCell('&laquo;Annotation&raquo;<br/><b>Component</b>', new mxGeometry(0, 0, 180, 90), 'html=1;');
			cell.vertex = true;

			let symbol = new mxCell('', new mxGeometry(1, 0, 20, 20), 'shape=component;jettyWidth=8;jettyHeight=4;');
			symbol.vertex = true;
			symbol.geometry.relative = true;
			symbol.geometry.offset = new mxPoint(-27, 7);
			cell.insert(symbol);

			return sb.createVertexTemplateFromCells([cell], cell.geometry.width, cell.geometry.height, 'Component');
		}),
		this.addEntry(dt + 'component', function () {
			let cell = new mxCell(
				'<p style="margin:0px;margin-top:6px;text-align:center;"><b>Component</b></p>' +
					'<hr/><p style="margin:0px;margin-left:8px;">+ Attribute1: Type<br/>+ Attribute2: Type</p>',
				new mxGeometry(0, 0, 180, 90),
				'align=left;overflow=fill;html=1;',
			);
			cell.vertex = true;

			let symbol = new mxCell('', new mxGeometry(1, 0, 20, 20), 'shape=component;jettyWidth=8;jettyHeight=4;');
			symbol.vertex = true;
			symbol.geometry.relative = true;
			symbol.geometry.offset = new mxPoint(-24, 4);
			cell.insert(symbol);

			return sb.createVertexTemplateFromCells(
				[cell],
				cell.geometry.width,
				cell.geometry.height,
				'Component with Attributes',
			);
		}),
		this.createVertexTemplateEntry(
			'verticalAlign=top;align=left;spacingTop=8;spacingLeft=2;spacingRight=12;shape=cube;size=10;direction=south;fontStyle=4;html=1;',
			180,
			120,
			'Block',
			'Block',
			null,
			null,
			dt + 'block',
		),
		this.createVertexTemplateEntry(
			'shape=component;align=left;spacingLeft=36;',
			120,
			60,
			'Module',
			'Module',
			null,
			null,
			dt + 'module',
		),
		this.createVertexTemplateEntry(
			'shape=folder;fontStyle=1;spacingTop=10;tabWidth=40;tabHeight=14;tabPosition=left;html=1;',
			70,
			50,
			'package',
			'Package',
			null,
			null,
			dt + 'package',
		),
		this.createVertexTemplateEntry(
			'verticalAlign=top;align=left;overflow=fill;fontSize=12;fontFamily=Helvetica;html=1;',
			160,
			90,
			'<p style="margin:0px;margin-top:4px;text-align:center;text-decoration:underline;"><b>Object:Type</b></p><hr/>' +
				'<p style="margin:0px;margin-left:8px;">field1 = value1<br/>field2 = value2<br>field3 = value3</p>',
			'Object',
			null,
			null,
			dt + 'object instance',
		),
		this.createVertexTemplateEntry(
			'verticalAlign=top;align=left;overflow=fill;html=1;',
			180,
			90,
			'<div style="box-sizing:border-box;width:100%;background:#e4e4e4;padding:2px;">Tablename</div>' +
				'<table style="width:100%;font-size:1em;" cellpadding="2" cellspacing="0">' +
				'<tr><td>PK</td><td>uniqueId</td></tr><tr><td>FK1</td><td>' +
				'foreignKey</td></tr><tr><td></td><td>fieldname</td></tr></table>',
			'Entity',
			null,
			null,
			'er entity table',
		),
		this.addEntry(dt + 'object instance', function () {
			let cell = new mxCell(
				'<p style="margin:0px;margin-top:4px;text-align:center;">' +
					'<b>Class</b></p>' +
					'<hr size="1"/><div style="height:2px;"></div>',
				new mxGeometry(0, 0, 140, 60),
				'verticalAlign=top;align=left;overflow=fill;fontSize=12;fontFamily=Helvetica;html=1;',
			);
			cell.vertex = true;

			return sb.createVertexTemplateFromCells([cell.clone()], cell.geometry.width, cell.geometry.height, 'Class 3');
		}),
		this.addEntry(dt + 'object instance', function () {
			let cell = new mxCell(
				'<p style="margin:0px;margin-top:4px;text-align:center;">' +
					'<b>Class</b></p>' +
					'<hr size="1"/><div style="height:2px;"></div><hr size="1"/><div style="height:2px;"></div>',
				new mxGeometry(0, 0, 140, 60),
				'verticalAlign=top;align=left;overflow=fill;fontSize=12;fontFamily=Helvetica;html=1;',
			);
			cell.vertex = true;

			return sb.createVertexTemplateFromCells([cell.clone()], cell.geometry.width, cell.geometry.height, 'Class 4');
		}),
		this.addEntry(dt + 'object instance', function () {
			let cell = new mxCell(
				'<p style="margin:0px;margin-top:4px;text-align:center;">' +
					'<b>Class</b></p>' +
					'<hr size="1"/><p style="margin:0px;margin-left:4px;">+ field: Type</p><hr size="1"/>' +
					'<p style="margin:0px;margin-left:4px;">+ method(): Type</p>',
				new mxGeometry(0, 0, 160, 90),
				'verticalAlign=top;align=left;overflow=fill;fontSize=12;fontFamily=Helvetica;html=1;',
			);
			cell.vertex = true;

			return sb.createVertexTemplateFromCells([cell.clone()], cell.geometry.width, cell.geometry.height, 'Class 5');
		}),
		this.addEntry(dt + 'object instance', function () {
			let cell = new mxCell(
				'<p style="margin:0px;margin-top:4px;text-align:center;">' +
					'<i>&lt;&lt;Interface&gt;&gt;</i><br/><b>Interface</b></p>' +
					'<hr size="1"/><p style="margin:0px;margin-left:4px;">+ field1: Type<br/>' +
					'+ field2: Type</p>' +
					'<hr size="1"/><p style="margin:0px;margin-left:4px;">' +
					'+ method1(Type): Type<br/>' +
					'+ method2(Type, Type): Type</p>',
				new mxGeometry(0, 0, 190, 140),
				'verticalAlign=top;align=left;overflow=fill;fontSize=12;fontFamily=Helvetica;html=1;',
			);
			cell.vertex = true;

			return sb.createVertexTemplateFromCells([cell.clone()], cell.geometry.width, cell.geometry.height, 'Interface 2');
		}),
		this.createVertexTemplateEntry(
			'shape=lollipop;direction=south;html=1;',
			30,
			10,
			'',
			'Provided Interface',
			null,
			null,
			dt + 'provided interface',
		),
		this.createVertexTemplateEntry(
			'shape=requires;direction=north;html=1;',
			30,
			20,
			'',
			'Required Interface',
			null,
			null,
			dt + 'required interface',
		),
		this.createVertexTemplateEntry(
			'shape=umlBoundary;whiteSpace=wrap;html=1;',
			100,
			80,
			'Boundary Object',
			'Boundary Object',
			null,
			null,
			'uml boundary object',
		),
		this.createVertexTemplateEntry(
			'ellipse;shape=umlEntity;whiteSpace=wrap;html=1;',
			80,
			80,
			'Entity Object',
			'Entity Object',
			null,
			null,
			'uml entity object',
		),
		this.createVertexTemplateEntry(
			'ellipse;shape=umlControl;whiteSpace=wrap;html=1;',
			70,
			80,
			'Control Object',
			'Control Object',
			null,
			null,
			'uml control object',
		),
		this.createVertexTemplateEntry(
			'shape=umlActor;verticalLabelPosition=bottom;labelBackgroundColor=#ffffff;verticalAlign=top;html=1;',
			30,
			60,
			'Actor',
			'Actor',
			false,
			null,
			'uml actor',
		),
		this.createVertexTemplateEntry(
			'ellipse;whiteSpace=wrap;html=1;',
			140,
			70,
			'Use Case',
			'Use Case',
			null,
			null,
			'uml use case usecase',
		),
		this.addEntry('uml activity state start', function () {
			let cell = new mxCell(
				'',
				new mxGeometry(0, 0, 30, 30),
				'ellipse;html=1;shape=startState;fillColor=#000000;strokeColor=#ff0000;',
			);
			cell.vertex = true;

			let edge = new mxCell(
				'',
				new mxGeometry(0, 0, 0, 0),
				'edgeStyle=orthogonalEdgeStyle;html=1;verticalAlign=bottom;endArrow=open;endSize=8;strokeColor=#ff0000;',
			);
			edge.geometry.setTerminalPoint(new mxPoint(15, 90), false);
			edge.geometry.relative = true;
			edge.edge = true;

			cell.insertEdge(edge, true);

			return sb.createVertexTemplateFromCells([cell, edge], 30, 90, 'Start');
		}),
		this.addEntry('uml activity state', function () {
			let cell = new mxCell(
				'Activity',
				new mxGeometry(0, 0, 120, 40),
				'rounded=1;whiteSpace=wrap;html=1;arcSize=40;fillColor=#ffffc0;strokeColor=#ff0000;',
			);
			cell.vertex = true;

			let edge = new mxCell(
				'',
				new mxGeometry(0, 0, 0, 0),
				'edgeStyle=orthogonalEdgeStyle;html=1;verticalAlign=bottom;endArrow=open;endSize=8;strokeColor=#ff0000;',
			);
			edge.geometry.setTerminalPoint(new mxPoint(60, 100), false);
			edge.geometry.relative = true;
			edge.edge = true;

			cell.insertEdge(edge, true);

			return sb.createVertexTemplateFromCells([cell, edge], 120, 100, 'Activity');
		}),
		this.addEntry('uml activity composite state', function () {
			let cell = new mxCell(
				'Composite State',
				new mxGeometry(0, 0, 160, 60),
				'swimlane;html=1;fontStyle=1;align=center;verticalAlign=middle;childLayout=stackLayout;horizontal=1;startSize=30;horizontalStack=0;resizeParent=0;resizeLast=1;container=0;collapsible=0;rounded=1;arcSize=30;strokeColor=#ff0000;fillColor=#ffffc0;swimlaneFillColor=#ffffc0;',
			);
			cell.vertex = true;

			let cell1 = new mxCell(
				'Subtitle',
				new mxGeometry(0, 0, 200, 26),
				'text;html=1;strokeColor=none;fillColor=none;align=center;verticalAlign=middle;spacingLeft=4;spacingRight=4;whiteSpace=wrap;overflow=hidden;rotatable=0;',
			);
			cell1.vertex = true;
			cell.insert(cell1);

			let edge = new mxCell(
				'',
				new mxGeometry(0, 0, 0, 0),
				'edgeStyle=orthogonalEdgeStyle;html=1;verticalAlign=bottom;endArrow=open;endSize=8;strokeColor=#ff0000;',
			);
			edge.geometry.setTerminalPoint(new mxPoint(80, 120), false);
			edge.geometry.relative = true;
			edge.edge = true;

			cell.insertEdge(edge, true);

			return sb.createVertexTemplateFromCells([cell, edge], 160, 120, 'Composite State');
		}),
		this.addEntry('uml activity condition', function () {
			let cell = new mxCell(
				'Condition',
				new mxGeometry(0, 0, 80, 40),
				'rhombus;whiteSpace=wrap;html=1;fillColor=#ffffc0;strokeColor=#ff0000;',
			);
			cell.vertex = true;

			let edge1 = new mxCell(
				'no',
				new mxGeometry(0, 0, 0, 0),
				'edgeStyle=orthogonalEdgeStyle;html=1;align=left;verticalAlign=bottom;endArrow=open;endSize=8;strokeColor=#ff0000;',
			);
			edge1.geometry.setTerminalPoint(new mxPoint(180, 20), false);
			edge1.geometry.relative = true;
			edge1.geometry.x = -1;
			edge1.edge = true;

			cell.insertEdge(edge1, true);

			let edge2 = new mxCell(
				'yes',
				new mxGeometry(0, 0, 0, 0),
				'edgeStyle=orthogonalEdgeStyle;html=1;align=left;verticalAlign=top;endArrow=open;endSize=8;strokeColor=#ff0000;',
			);
			edge2.geometry.setTerminalPoint(new mxPoint(40, 100), false);
			edge2.geometry.relative = true;
			edge2.geometry.x = -1;
			edge2.edge = true;

			cell.insertEdge(edge2, true);

			return sb.createVertexTemplateFromCells([cell, edge1, edge2], 180, 100, 'Condition');
		}),
		this.addEntry('uml activity fork join', function () {
			let cell = new mxCell('', new mxGeometry(0, 0, 200, 10), 'shape=line;html=1;strokeWidth=6;strokeColor=#ff0000;');
			cell.vertex = true;

			let edge = new mxCell(
				'',
				new mxGeometry(0, 0, 0, 0),
				'edgeStyle=orthogonalEdgeStyle;html=1;verticalAlign=bottom;endArrow=open;endSize=8;strokeColor=#ff0000;',
			);
			edge.geometry.setTerminalPoint(new mxPoint(100, 80), false);
			edge.geometry.relative = true;
			edge.edge = true;

			cell.insertEdge(edge, true);

			return sb.createVertexTemplateFromCells([cell, edge], 200, 80, 'Fork/Join');
		}),
		this.createVertexTemplateEntry(
			'ellipse;html=1;shape=endState;fillColor=#000000;strokeColor=#ff0000;',
			30,
			30,
			'',
			'End',
			null,
			null,
			'uml activity state end',
		),
		this.createVertexTemplateEntry(
			'shape=umlLifeline;perimeter=lifelinePerimeter;whiteSpace=wrap;html=1;container=1;collapsible=0;recursiveResize=0;outlineConnect=0;',
			100,
			300,
			':Object',
			'Lifeline',
			null,
			null,
			'uml sequence participant lifeline',
		),
		this.createVertexTemplateEntry(
			'shape=umlLifeline;participant=umlActor;perimeter=lifelinePerimeter;whiteSpace=wrap;html=1;container=1;collapsible=0;recursiveResize=0;verticalAlign=top;spacingTop=36;labelBackgroundColor=#ffffff;outlineConnect=0;',
			20,
			300,
			'',
			'Actor Lifeline',
			null,
			null,
			'uml sequence participant lifeline actor',
		),
		this.createVertexTemplateEntry(
			'shape=umlLifeline;participant=umlBoundary;perimeter=lifelinePerimeter;whiteSpace=wrap;html=1;container=1;collapsible=0;recursiveResize=0;verticalAlign=top;spacingTop=36;labelBackgroundColor=#ffffff;outlineConnect=0;',
			50,
			300,
			'',
			'Boundary Lifeline',
			null,
			null,
			'uml sequence participant lifeline boundary',
		),
		this.createVertexTemplateEntry(
			'shape=umlLifeline;participant=umlEntity;perimeter=lifelinePerimeter;whiteSpace=wrap;html=1;container=1;collapsible=0;recursiveResize=0;verticalAlign=top;spacingTop=36;labelBackgroundColor=#ffffff;outlineConnect=0;',
			40,
			300,
			'',
			'Entity Lifeline',
			null,
			null,
			'uml sequence participant lifeline entity',
		),
		this.createVertexTemplateEntry(
			'shape=umlLifeline;participant=umlControl;perimeter=lifelinePerimeter;whiteSpace=wrap;html=1;container=1;collapsible=0;recursiveResize=0;verticalAlign=top;spacingTop=36;labelBackgroundColor=#ffffff;outlineConnect=0;',
			40,
			300,
			'',
			'Control Lifeline',
			null,
			null,
			'uml sequence participant lifeline control',
		),
		this.createVertexTemplateEntry(
			'shape=umlFrame;whiteSpace=wrap;html=1;',
			300,
			200,
			'frame',
			'Frame',
			null,
			null,
			'uml sequence frame',
		),
		this.createVertexTemplateEntry(
			'shape=umlDestroy;whiteSpace=wrap;html=1;strokeWidth=3;',
			30,
			30,
			'',
			'Destruction',
			null,
			null,
			'uml sequence destruction destroy',
		),
		this.createVertexTemplateEntry(
			'shape=note;whiteSpace=wrap;html=1;size=14;verticalAlign=top;align=left;spacingTop=-6;',
			100,
			70,
			'Note',
			'Note',
			null,
			null,
			'uml note',
		),
		this.addEntry('uml sequence invoke invocation call activation', function () {
			let cell = new mxCell('', new mxGeometry(0, 0, 10, 80), 'html=1;points=[];perimeter=orthogonalPerimeter;');
			cell.vertex = true;

			let edge = new mxCell(
				'dispatch',
				new mxGeometry(0, 0, 0, 0),
				'html=1;verticalAlign=bottom;startArrow=oval;endArrow=block;startSize=8;',
			);
			edge.geometry.setTerminalPoint(new mxPoint(-60, 0), true);
			edge.geometry.relative = true;
			edge.edge = true;

			cell.insertEdge(edge, false);

			return sb.createVertexTemplateFromCells([cell, edge], 10, 80, 'Found Message');
		}),
		this.addEntry('uml sequence invoke call delegation synchronous invocation activation', function () {
			let cell = new mxCell('', new mxGeometry(0, 0, 10, 80), 'html=1;points=[];perimeter=orthogonalPerimeter;');
			cell.vertex = true;

			let edge1 = new mxCell(
				'dispatch',
				new mxGeometry(0, 0, 0, 0),
				'html=1;verticalAlign=bottom;endArrow=block;entryX=0;entryY=0;',
			);
			edge1.geometry.setTerminalPoint(new mxPoint(-70, 0), true);
			edge1.geometry.relative = true;
			edge1.edge = true;

			cell.insertEdge(edge1, false);

			let edge2 = new mxCell(
				'return',
				new mxGeometry(0, 0, 0, 0),
				'html=1;verticalAlign=bottom;endArrow=open;dashed=1;endSize=8;exitX=0;exitY=0.95;',
			);
			edge2.geometry.setTerminalPoint(new mxPoint(-70, 76), false);
			edge2.geometry.relative = true;
			edge2.edge = true;

			cell.insertEdge(edge2, true);

			return sb.createVertexTemplateFromCells([cell, edge1, edge2], 10, 80, 'Synchronous Invocation');
		}),
		this.addEntry('uml sequence self call recursion delegation activation', function () {
			let cell = new mxCell('', new mxGeometry(0, 20, 10, 40), 'html=1;points=[];perimeter=orthogonalPerimeter;');
			cell.vertex = true;

			let edge = new mxCell(
				'self call',
				new mxGeometry(0, 0, 0, 0),
				'edgeStyle=orthogonalEdgeStyle;html=1;align=left;spacingLeft=2;endArrow=block;rounded=0;entryX=1;entryY=0;',
			);
			edge.geometry.setTerminalPoint(new mxPoint(5, 0), true);
			edge.geometry.points = [new mxPoint(30, 0)];
			edge.geometry.relative = true;
			edge.edge = true;

			cell.insertEdge(edge, false);

			return sb.createVertexTemplateFromCells([cell, edge], 10, 60, 'Self Call');
		}),
		this.addEntry('uml sequence invoke call delegation callback activation', function () {
			let cell = new mxCell('', new mxGeometry(0, 0, 10, 60), 'html=1;points=[];perimeter=orthogonalPerimeter;');
			cell.vertex = true;

			let edge1 = new mxCell(
				'callback',
				new mxGeometry(0, 0, 0, 0),
				'html=1;verticalAlign=bottom;endArrow=block;entryX=1;entryY=0;',
			);
			edge1.geometry.setTerminalPoint(new mxPoint(70, 0), true);
			edge1.geometry.relative = true;
			edge1.edge = true;

			cell.insertEdge(edge1, false);

			let edge2 = new mxCell(
				'return',
				new mxGeometry(0, 0, 0, 0),
				'html=1;verticalAlign=bottom;endArrow=open;dashed=1;endSize=8;exitX=1;exitY=0.95;',
			);
			edge2.geometry.setTerminalPoint(new mxPoint(70, 57), false);
			edge2.geometry.relative = true;
			edge2.edge = true;

			cell.insertEdge(edge2, true);

			return sb.createVertexTemplateFromCells([cell, edge1, edge2], 10, 60, 'Callback');
		}),
		this.createVertexTemplateEntry(
			'html=1;points=[];perimeter=orthogonalPerimeter;',
			10,
			80,
			'',
			'Activation',
			null,
			null,
			'uml sequence activation',
		),
		this.createEdgeTemplateEntry(
			'html=1;verticalAlign=bottom;startArrow=oval;startFill=1;endArrow=block;startSize=8;',
			60,
			0,
			'dispatch',
			'Found Message 1',
			null,
			'uml sequence message call invoke dispatch',
		),
		this.createEdgeTemplateEntry(
			'html=1;verticalAlign=bottom;startArrow=circle;startFill=1;endArrow=open;startSize=6;endSize=8;',
			80,
			0,
			'dispatch',
			'Found Message 2',
			null,
			'uml sequence message call invoke dispatch',
		),
		this.createEdgeTemplateEntry(
			'html=1;verticalAlign=bottom;endArrow=block;',
			80,
			0,
			'dispatch',
			'Message',
			null,
			'uml sequence message call invoke dispatch',
		),
		this.addEntry('uml sequence return message', function () {
			let edge = new mxCell(
				'return',
				new mxGeometry(0, 0, 0, 0),
				'html=1;verticalAlign=bottom;endArrow=open;dashed=1;endSize=8;',
			);
			edge.geometry.setTerminalPoint(new mxPoint(80, 0), true);
			edge.geometry.setTerminalPoint(new mxPoint(0, 0), false);
			edge.geometry.relative = true;
			edge.edge = true;

			return sb.createEdgeTemplateFromCells([edge], 80, 0, 'Return');
		}),
		this.addEntry('uml relation', function () {
			let edge = new mxCell(
				'name',
				new mxGeometry(0, 0, 0, 0),
				'endArrow=block;endFill=1;html=1;edgeStyle=orthogonalEdgeStyle;align=left;verticalAlign=top;',
			);
			edge.geometry.setTerminalPoint(new mxPoint(0, 0), true);
			edge.geometry.setTerminalPoint(new mxPoint(160, 0), false);
			edge.geometry.relative = true;
			edge.geometry.x = -1;
			edge.edge = true;

			let cell = new mxCell(
				'1',
				new mxGeometry(-1, 0, 0, 0),
				'resizable=0;html=1;align=left;verticalAlign=bottom;labelBackgroundColor=#ffffff;fontSize=10;',
			);
			cell.geometry.relative = true;
			cell.setConnectable(false);
			cell.vertex = true;
			edge.insert(cell);

			return sb.createEdgeTemplateFromCells([edge], 160, 0, 'Relation 1');
		}),
		this.addEntry('uml association', function () {
			let edge = new mxCell('', new mxGeometry(0, 0, 0, 0), 'endArrow=none;html=1;edgeStyle=orthogonalEdgeStyle;');
			edge.geometry.setTerminalPoint(new mxPoint(0, 0), true);
			edge.geometry.setTerminalPoint(new mxPoint(160, 0), false);
			edge.geometry.relative = true;
			edge.edge = true;

			let cell1 = new mxCell(
				'parent',
				new mxGeometry(-1, 0, 0, 0),
				'resizable=0;html=1;align=left;verticalAlign=bottom;labelBackgroundColor=#ffffff;fontSize=10;',
			);
			cell1.geometry.relative = true;
			cell1.setConnectable(false);
			cell1.vertex = true;
			edge.insert(cell1);

			let cell2 = new mxCell(
				'child',
				new mxGeometry(1, 0, 0, 0),
				'resizable=0;html=1;align=right;verticalAlign=bottom;labelBackgroundColor=#ffffff;fontSize=10;',
			);
			cell2.geometry.relative = true;
			cell2.setConnectable(false);
			cell2.vertex = true;
			edge.insert(cell2);

			return sb.createEdgeTemplateFromCells([edge], 160, 0, 'Association 1');
		}),
		this.addEntry('uml aggregation', function () {
			let edge = new mxCell(
				'1',
				new mxGeometry(0, 0, 0, 0),
				'endArrow=open;html=1;endSize=12;startArrow=diamondThin;startSize=14;startFill=0;edgeStyle=orthogonalEdgeStyle;align=left;verticalAlign=bottom;',
			);
			edge.geometry.setTerminalPoint(new mxPoint(0, 0), true);
			edge.geometry.setTerminalPoint(new mxPoint(160, 0), false);
			edge.geometry.relative = true;
			edge.geometry.x = -1;
			edge.geometry.y = 3;
			edge.edge = true;

			return sb.createEdgeTemplateFromCells([edge], 160, 0, 'Aggregation 1');
		}),
		this.addEntry('uml composition', function () {
			let edge = new mxCell(
				'1',
				new mxGeometry(0, 0, 0, 0),
				'endArrow=open;html=1;endSize=12;startArrow=diamondThin;startSize=14;startFill=1;edgeStyle=orthogonalEdgeStyle;align=left;verticalAlign=bottom;',
			);
			edge.geometry.setTerminalPoint(new mxPoint(0, 0), true);
			edge.geometry.setTerminalPoint(new mxPoint(160, 0), false);
			edge.geometry.relative = true;
			edge.geometry.x = -1;
			edge.geometry.y = 3;
			edge.edge = true;

			return sb.createEdgeTemplateFromCells([edge], 160, 0, 'Composition 1');
		}),
		this.addEntry('uml relation', function () {
			let edge = new mxCell(
				'Relation',
				new mxGeometry(0, 0, 0, 0),
				'endArrow=open;html=1;endSize=12;startArrow=diamondThin;startSize=14;startFill=0;edgeStyle=orthogonalEdgeStyle;',
			);
			edge.geometry.setTerminalPoint(new mxPoint(0, 0), true);
			edge.geometry.setTerminalPoint(new mxPoint(160, 0), false);
			edge.geometry.relative = true;
			edge.edge = true;

			let cell1 = new mxCell(
				'0..n',
				new mxGeometry(-1, 0, 0, 0),
				'resizable=0;html=1;align=left;verticalAlign=top;labelBackgroundColor=#ffffff;fontSize=10;',
			);
			cell1.geometry.relative = true;
			cell1.setConnectable(false);
			cell1.vertex = true;
			edge.insert(cell1);

			let cell2 = new mxCell(
				'1',
				new mxGeometry(1, 0, 0, 0),
				'resizable=0;html=1;align=right;verticalAlign=top;labelBackgroundColor=#ffffff;fontSize=10;',
			);
			cell2.geometry.relative = true;
			cell2.setConnectable(false);
			cell2.vertex = true;
			edge.insert(cell2);

			return sb.createEdgeTemplateFromCells([edge], 160, 0, 'Relation 2');
		}),
		this.createEdgeTemplateEntry(
			'endArrow=open;endSize=12;dashed=1;html=1;',
			160,
			0,
			'Use',
			'Dependency',
			null,
			'uml dependency use',
		),
		this.createEdgeTemplateEntry(
			'endArrow=block;endSize=16;endFill=0;html=1;',
			160,
			0,
			'Extends',
			'Generalization',
			null,
			'uml generalization extend',
		),
		this.createEdgeTemplateEntry(
			'endArrow=block;startArrow=block;endFill=1;startFill=1;html=1;',
			160,
			0,
			'',
			'Association 2',
			null,
			'uml association',
		),
		this.createEdgeTemplateEntry(
			'endArrow=open;startArrow=circlePlus;endFill=0;startFill=0;endSize=8;html=1;',
			160,
			0,
			'',
			'Inner Class',
			null,
			'inner class',
		),
		this.createEdgeTemplateEntry(
			'endArrow=open;startArrow=cross;endFill=0;startFill=0;endSize=8;startSize=10;html=1;',
			160,
			0,
			'',
			'Terminate',
			null,
			'terminate',
		),
		this.createEdgeTemplateEntry(
			'endArrow=block;dashed=1;endFill=0;endSize=12;html=1;',
			160,
			0,
			'',
			'Implementation',
			null,
			'realization implementation',
		),
		this.createEdgeTemplateEntry(
			'endArrow=diamondThin;endFill=0;endSize=24;html=1;',
			160,
			0,
			'',
			'Aggregation 2',
			null,
			'aggregation',
		),
		this.createEdgeTemplateEntry(
			'endArrow=diamondThin;endFill=1;endSize=24;html=1;',
			160,
			0,
			'',
			'Composition 2',
			null,
			'composition',
		),
		this.createEdgeTemplateEntry(
			'endArrow=open;endFill=1;endSize=12;html=1;',
			160,
			0,
			'',
			'Association 3',
			null,
			'association',
		),
	];

	this.addPaletteFunctions('uml', mxResources.get('uml'), expand || false, fns);
};

/**
 * Adds the BPMN library to the sidebar.
 */
Sidebar.prototype.addBpmnPalette = function (dir, expand) {
	// Avoids having to bind all functions to "this"
	let sb = this;

	let fns = [
		this.createVertexTemplateEntry(
			'shape=ext;rounded=1;html=1;whiteSpace=wrap;',
			120,
			80,
			'Task',
			'Process',
			null,
			null,
			'bpmn task process',
		),
		this.createVertexTemplateEntry(
			'shape=ext;rounded=1;html=1;whiteSpace=wrap;double=1;',
			120,
			80,
			'Transaction',
			'Transaction',
			null,
			null,
			'bpmn transaction',
		),
		this.createVertexTemplateEntry(
			'shape=ext;rounded=1;html=1;whiteSpace=wrap;dashed=1;dashPattern=1 4;',
			120,
			80,
			'Event\nSub-Process',
			'Event Sub-Process',
			null,
			null,
			'bpmn event subprocess sub process sub-process',
		),
		this.createVertexTemplateEntry(
			'shape=ext;rounded=1;html=1;whiteSpace=wrap;strokeWidth=3;',
			120,
			80,
			'Call Activity',
			'Call Activity',
			null,
			null,
			'bpmn call activity',
		),
		this.addEntry('bpmn subprocess sub process sub-process', function () {
			let cell = new mxCell('Sub-Process', new mxGeometry(0, 0, 120, 80), 'html=1;whiteSpace=wrap;rounded=1;');
			cell.vertex = true;

			let cell1 = new mxCell('', new mxGeometry(0.5, 1, 14, 14), 'html=1;shape=plus;');
			cell1.vertex = true;
			cell1.geometry.relative = true;
			cell1.geometry.offset = new mxPoint(-7, -14);
			cell.insert(cell1);

			return sb.createVertexTemplateFromCells([cell], cell.geometry.width, cell.geometry.height, 'Sub-Process');
		}),
		this.addEntry(
			this.getTagsForStencil('mxgraph.bpmn', 'loop', 'subprocess sub process sub-process looped').join(' '),
			function () {
				let cell = new mxCell('Looped\nSub-Process', new mxGeometry(0, 0, 120, 80), 'html=1;whiteSpace=wrap;rounded=1');
				cell.vertex = true;

				let cell1 = new mxCell('', new mxGeometry(0.5, 1, 14, 14), 'html=1;shape=mxgraph.bpmn.loop;');
				cell1.vertex = true;
				cell1.geometry.relative = true;
				cell1.geometry.offset = new mxPoint(-15, -14);
				cell.insert(cell1);

				let cell2 = new mxCell('', new mxGeometry(0.5, 1, 14, 14), 'html=1;shape=plus;');
				cell2.vertex = true;
				cell2.geometry.relative = true;
				cell2.geometry.offset = new mxPoint(1, -14);
				cell.insert(cell2);

				return sb.createVertexTemplateFromCells(
					[cell],
					cell.geometry.width,
					cell.geometry.height,
					'Looped Sub-Process',
				);
			},
		),
		this.addEntry('bpmn receive task', function () {
			let cell = new mxCell('Receive', new mxGeometry(0, 0, 120, 80), 'html=1;whiteSpace=wrap;rounded=1;');
			cell.vertex = true;

			let cell1 = new mxCell('', new mxGeometry(0, 0, 20, 14), 'html=1;shape=message;');
			cell1.vertex = true;
			cell1.geometry.relative = true;
			cell1.geometry.offset = new mxPoint(7, 7);
			cell.insert(cell1);

			return sb.createVertexTemplateFromCells([cell], cell.geometry.width, cell.geometry.height, 'Receive Task');
		}),
		this.addEntry(this.getTagsForStencil('mxgraph.bpmn', 'user_task').join(' '), function () {
			let cell = new mxCell('User', new mxGeometry(0, 0, 120, 80), 'html=1;whiteSpace=wrap;rounded=1;');
			cell.vertex = true;

			let cell1 = new mxCell('', new mxGeometry(0, 0, 14, 14), 'html=1;shape=mxgraph.bpmn.user_task;');
			cell1.vertex = true;
			cell1.geometry.relative = true;
			cell1.geometry.offset = new mxPoint(7, 7);
			cell.insert(cell1);

			let cell2 = new mxCell('', new mxGeometry(0.5, 1, 14, 14), 'html=1;shape=plus;');
			cell2.vertex = true;
			cell2.geometry.relative = true;
			cell2.geometry.offset = new mxPoint(-7, -14);
			cell.insert(cell2);

			return sb.createVertexTemplateFromCells([cell], cell.geometry.width, cell.geometry.height, 'User Task');
		}),
		this.addEntry(this.getTagsForStencil('mxgraph.bpmn', 'timer_start', 'attached').join(' '), function () {
			let cell = new mxCell('Process', new mxGeometry(0, 0, 120, 80), 'html=1;whiteSpace=wrap;rounded=1;');
			cell.vertex = true;

			let cell1 = new mxCell(
				'',
				new mxGeometry(1, 1, 30, 30),
				'shape=mxgraph.bpmn.timer_start;perimeter=ellipsePerimeter;html=1;verticalLabelPosition=bottom;labelBackgroundColor=#ffffff;verticalAlign=top;',
			);
			cell1.vertex = true;
			cell1.geometry.relative = true;
			cell1.geometry.offset = new mxPoint(-40, -15);
			cell.insert(cell1);

			return sb.createVertexTemplateFromCells([cell], 120, 95, 'Attached Timer Event 1');
		}),
		this.addEntry(this.getTagsForStencil('mxgraph.bpmn', 'timer_start', 'attached').join(' '), function () {
			let cell = new mxCell('Process', new mxGeometry(0, 0, 120, 80), 'html=1;whiteSpace=wrap;rounded=1;');
			cell.vertex = true;

			let cell1 = new mxCell(
				'',
				new mxGeometry(1, 0, 30, 30),
				'shape=mxgraph.bpmn.timer_start;perimeter=ellipsePerimeter;html=1;labelPosition=right;labelBackgroundColor=#ffffff;align=left;',
			);
			cell1.vertex = true;
			cell1.geometry.relative = true;
			cell1.geometry.offset = new mxPoint(-15, 10);
			cell.insert(cell1);

			return sb.createVertexTemplateFromCells([cell], 135, 80, 'Attached Timer Event 2');
		}),
		this.createVertexTemplateEntry(
			'swimlane;html=1;horizontal=0;startSize=20;',
			320,
			240,
			'Pool',
			'Pool',
			null,
			null,
			'bpmn pool',
		),
		this.createVertexTemplateEntry(
			'swimlane;html=1;horizontal=0;swimlaneFillColor=white;swimlaneLine=0;',
			300,
			120,
			'Lane',
			'Lane',
			null,
			null,
			'bpmn lane',
		),
		this.createVertexTemplateEntry(
			'shape=hexagon;html=1;whiteSpace=wrap;perimeter=hexagonPerimeter;',
			60,
			50,
			'',
			'Conversation',
			null,
			null,
			'bpmn conversation',
		),
		this.createVertexTemplateEntry(
			'shape=hexagon;html=1;whiteSpace=wrap;perimeter=hexagonPerimeter;strokeWidth=4',
			60,
			50,
			'',
			'Call Conversation',
			null,
			null,
			'bpmn call conversation',
		),
		this.addEntry('bpmn subconversation sub conversation sub-conversation', function () {
			let cell = new mxCell(
				'',
				new mxGeometry(0, 0, 60, 50),
				'shape=hexagon;whiteSpace=wrap;html=1;perimeter=hexagonPerimeter;',
			);
			cell.vertex = true;

			let cell1 = new mxCell('', new mxGeometry(0.5, 1, 14, 14), 'html=1;shape=plus;');
			cell1.vertex = true;
			cell1.geometry.relative = true;
			cell1.geometry.offset = new mxPoint(-7, -14);
			cell.insert(cell1);

			return sb.createVertexTemplateFromCells([cell], cell.geometry.width, cell.geometry.height, 'Sub-Conversation');
		}),
		this.addEntry('bpmn data object', function () {
			let cell = new mxCell('', new mxGeometry(0, 0, 40, 60), 'shape=note;whiteSpace=wrap;size=16;html=1;');
			cell.vertex = true;

			let cell1 = new mxCell(
				'',
				new mxGeometry(0, 0, 14, 14),
				'html=1;shape=singleArrow;arrowWidth=0.4;arrowSize=0.4;',
			);
			cell1.vertex = true;
			cell1.geometry.relative = true;
			cell1.geometry.offset = new mxPoint(2, 2);
			cell.insert(cell1);

			let cell2 = new mxCell('', new mxGeometry(0.5, 1, 14, 14), 'html=1;whiteSpace=wrap;shape=parallelMarker;');
			cell2.vertex = true;
			cell2.geometry.relative = true;
			cell2.geometry.offset = new mxPoint(-7, -14);
			cell.insert(cell2);

			return sb.createVertexTemplateFromCells([cell], cell.geometry.width, cell.geometry.height, 'Data Object');
		}),
		this.createVertexTemplateEntry(
			'shape=datastore;whiteSpace=wrap;html=1;',
			60,
			60,
			'',
			'Data Store',
			null,
			null,
			'bpmn data store',
		),
		this.createVertexTemplateEntry(
			'shape=plus;html=1;',
			14,
			14,
			'',
			'Sub-Process Marker',
			null,
			null,
			'bpmn subprocess sub process sub-process marker',
		),
		this.createVertexTemplateEntry(
			'shape=mxgraph.bpmn.loop;html=1;',
			14,
			14,
			'',
			'Loop Marker',
			null,
			null,
			'bpmn loop marker',
		),
		this.createVertexTemplateEntry(
			'shape=parallelMarker;html=1;',
			14,
			14,
			'',
			'Parallel MI Marker',
			null,
			null,
			'bpmn parallel mi marker',
		),
		this.createVertexTemplateEntry(
			'shape=parallelMarker;direction=south;html=1;',
			14,
			14,
			'',
			'Sequential MI Marker',
			null,
			null,
			'bpmn sequential mi marker',
		),
		this.createVertexTemplateEntry(
			'shape=mxgraph.bpmn.ad_hoc;fillColor=#000000;html=1;',
			14,
			14,
			'',
			'Ad Hoc Marker',
			null,
			null,
			'bpmn ad hoc marker',
		),
		this.createVertexTemplateEntry(
			'shape=mxgraph.bpmn.compensation;html=1;',
			14,
			14,
			'',
			'Compensation Marker',
			null,
			null,
			'bpmn compensation marker',
		),
		this.createVertexTemplateEntry(
			'shape=message;whiteSpace=wrap;html=1;fillColor=#000000;strokeColor=#ffffff;strokeWidth=2;',
			40,
			30,
			'',
			'Send Task',
			null,
			null,
			'bpmn send task',
		),
		this.createVertexTemplateEntry(
			'shape=message;whiteSpace=wrap;html=1;',
			40,
			30,
			'',
			'Receive Task',
			null,
			null,
			'bpmn receive task',
		),
		this.createVertexTemplateEntry(
			'shape=mxgraph.bpmn.user_task;html=1;',
			14,
			14,
			'',
			'User Task',
			null,
			null,
			this.getTagsForStencil('mxgraph.bpmn', 'user_task').join(' '),
		),
		this.createVertexTemplateEntry(
			'shape=mxgraph.bpmn.manual_task;html=1;',
			14,
			14,
			'',
			'Manual Task',
			null,
			null,
			this.getTagsForStencil('mxgraph.bpmn', 'user_task').join(' '),
		),
		this.createVertexTemplateEntry(
			'shape=mxgraph.bpmn.business_rule_task;html=1;',
			14,
			14,
			'',
			'Business Rule Task',
			null,
			null,
			this.getTagsForStencil('mxgraph.bpmn', 'business_rule_task').join(' '),
		),
		this.createVertexTemplateEntry(
			'shape=mxgraph.bpmn.service_task;html=1;',
			14,
			14,
			'',
			'Service Task',
			null,
			null,
			this.getTagsForStencil('mxgraph.bpmn', 'service_task').join(' '),
		),
		this.createVertexTemplateEntry(
			'shape=mxgraph.bpmn.script_task;html=1;',
			14,
			14,
			'',
			'Script Task',
			null,
			null,
			this.getTagsForStencil('mxgraph.bpmn', 'script_task').join(' '),
		),
		this.createEdgeTemplateEntry(
			'endArrow=block;endFill=1;endSize=6;html=1;',
			100,
			0,
			'',
			'Sequence Flow',
			null,
			'bpmn sequence flow',
		),
		this.createEdgeTemplateEntry(
			'startArrow=dash;startSize=8;endArrow=block;endFill=1;endSize=6;html=1;',
			100,
			0,
			'',
			'Default Flow',
			null,
			'bpmn default flow',
		),
		this.createEdgeTemplateEntry(
			'startArrow=diamondThin;startFill=0;startSize=14;endArrow=block;endFill=1;endSize=6;html=1;',
			100,
			0,
			'',
			'Conditional Flow',
			null,
			'bpmn conditional flow',
		),
		this.createEdgeTemplateEntry(
			'startArrow=oval;startFill=0;startSize=7;endArrow=block;endFill=0;endSize=10;dashed=1;html=1;',
			100,
			0,
			'',
			'Message Flow 1',
			null,
			'bpmn message flow',
		),
		this.addEntry('bpmn message flow', function () {
			let edge = new mxCell(
				'',
				new mxGeometry(0, 0, 0, 0),
				'startArrow=oval;startFill=0;startSize=7;endArrow=block;endFill=0;endSize=10;dashed=1;html=1;',
			);
			edge.geometry.setTerminalPoint(new mxPoint(0, 0), true);
			edge.geometry.setTerminalPoint(new mxPoint(100, 0), false);
			edge.geometry.relative = true;
			edge.edge = true;

			let cell = new mxCell('', new mxGeometry(0, 0, 20, 14), 'shape=message;html=1;');
			cell.geometry.relative = true;
			cell.setConnectable(false);
			cell.vertex = true;
			cell.geometry.offset = new mxPoint(-10, -7);
			edge.insert(cell);

			return sb.createEdgeTemplateFromCells([edge], 100, 0, 'Message Flow 2');
		}),
		this.createEdgeTemplateEntry('shape=link;html=1;', 100, 0, '', 'Link', null, 'bpmn link'),
	];

	this.addPaletteFunctions('bpmn', 'BPMN ' + mxResources.get('general'), false, fns);
};

/**
 * Creates a thumbnail for the given cells.
 */
Sidebar.prototype.createThumb = function (
	cells,
	width,
	height,
	parent,
	title,
	showLabel,
	showTitle,
	realWidth,
	realHeight,
) {
	this.graph.labelsVisible = showLabel == null || showLabel;
	let fo = mxClient.NO_FO;
	mxClient.NO_FO = Editor.prototype.originalNoForeignObject;
	this.graph.view.scaleAndTranslate(1, 0, 0);
	this.graph.addCells(cells);
	let bounds = this.graph.getGraphBounds();
	let s =
		Math.floor(
			Math.min((width - 2 * this.thumbBorder) / bounds.width, (height - 2 * this.thumbBorder) / bounds.height) * 100,
		) / 100;
	this.graph.view.scaleAndTranslate(
		s,
		Math.floor((width - bounds.width * s) / 2 / s - bounds.x),
		Math.floor((height - bounds.height * s) / 2 / s - bounds.y),
	);

	let node = null;

	// For supporting HTML labels in IE9 standards mode the container is cloned instead
	if (this.graph.dialect == mxConstants.DIALECT_SVG && !mxClient.NO_FO) {
		node = this.graph.view.getCanvas().ownerSVGElement.cloneNode(true);
	}
	// LATER: Check if deep clone can be used for quirks if container in DOM
	else {
		node = this.graph.container.cloneNode(false);
		node.innerHTML = this.graph.container.innerHTML;
	}

	this.graph.getModel().clear();
	mxClient.NO_FO = fo;

	// Catch-all event handling
	if (mxClient.IS_IE6) {
		parent.style.backgroundImage = 'url(' + this.editorUi.editor.transparentImage + ')';
	}

	node.style.position = 'relative';
	node.style.overflow = 'hidden';
	node.style.cursor = 'move';
	node.style.left = this.thumbBorder + 'px';
	node.style.top = this.thumbBorder + 'px';
	node.style.width = width + 'px';
	node.style.height = height + 'px';
	node.style.visibility = '';
	node.style.minWidth = '';
	node.style.minHeight = '';

	parent.appendChild(node);

	return bounds;
};

/**
 * Creates a drop handler for inserting the given cells.
 */
Sidebar.prototype.updateShapes = function (source, targets) {
	let graph = this.editorUi.editor.graph;
	let sourceCellStyle = graph.getCellStyle(source);
	let result = [];

	graph.model.beginUpdate();
	try {
		let cellStyle = graph.getModel().getStyle(source);

		// Lists the styles to carry over from the existing shape
		let styles = [
			'shadow',
			'dashed',
			'dashPattern',
			'fontFamily',
			'fontSize',
			'fontColor',
			'align',
			'startFill',
			'startSize',
			'endFill',
			'endSize',
			'strokeColor',
			'strokeWidth',
			'fillColor',
			'gradientColor',
			'html',
			'part',
			'noEdgeStyle',
			'edgeStyle',
			'elbow',
			'childLayout',
		];

		for (let i = 0; i < targets.length; i++) {
			let targetCell = targets[i];

			if (
				graph.getModel().isVertex(targetCell) == graph.getModel().isVertex(source) ||
				graph.getModel().isEdge(targetCell) == graph.getModel().isEdge(source)
			) {
				let state = graph.view.getState(targetCell);
				let style = state != null ? state.style : graph.getCellStyle(targets[i]);
				graph.getModel().setStyle(targetCell, cellStyle);

				// Removes all children of composite cells
				if (state != null && mxUtils.getValue(state.style, 'composite', '0') == '1') {
					let childCount = graph.model.getChildCount(targetCell);

					for (let j = childCount; j >= 0; j--) {
						graph.model.remove(graph.model.getChildAt(targetCell, j));
					}
				}

				if (style != null) {
					// Replaces the participant style in the lifeline shape with the target shape
					if (
						style[mxConstants.STYLE_SHAPE] == 'umlLifeline' &&
						sourceCellStyle[mxConstants.STYLE_SHAPE] != 'umlLifeline'
					) {
						graph.setCellStyles(mxConstants.STYLE_SHAPE, 'umlLifeline', [targetCell]);
						graph.setCellStyles('participant', sourceCellStyle[mxConstants.STYLE_SHAPE], [targetCell]);
					}

					for (let j = 0; j < styles.length; j++) {
						let value = style[styles[j]];

						if (value != null) {
							graph.setCellStyles(styles[j], value, [targetCell]);
						}
					}
				}

				result.push(targetCell);
			}
		}
	} finally {
		graph.model.endUpdate();
	}

	return result;
};

/**
 * Creates a drop handler for inserting the given cells.
 */
Sidebar.prototype.createDropHandler = function (cells, allowSplit, allowCellsInserted, bounds, removeLabel, realStyle) {
	allowCellsInserted = allowCellsInserted != null ? allowCellsInserted : true;

	return mxUtils.bind(this, function (graph, evt, target, x, y) {
		if (graph.isEnabled()) {
			cells = graph.getImportableCells(cells);

			if (cells.length > 0) {
				graph.stopEditing();

				// Holding alt while mouse is released ignores drop target
				let validDropTarget =
					target != null && !mxEvent.isAltDown(evt) ? graph.isValidDropTarget(target, cells, evt) : false;
				let select = null;

				if (target != null && !validDropTarget) {
					target = null;
				}

				if (!graph.isCellLocked(target || graph.getDefaultParent())) {
					graph.model.beginUpdate();
					try {
						x = Math.round(x);
						y = Math.round(y);

						// Splits the target edge or inserts into target group
						if (allowSplit && graph.isSplitTarget(target, cells, evt)) {
							let clones = graph.cloneCells(cells);
							graph.splitEdge(target, clones, null, x - bounds.width / 2, y - bounds.height / 2);
							select = clones;
						} else if (cells.length > 0) {
							select = graph.importCells(cells, x, y, target);
						}

						// Executes parent layout hooks for position/order
						if (graph.layoutManager != null) {
							let layout = graph.layoutManager.getLayout(target);

							if (layout != null) {
								let s = graph.view.scale;
								let tr = graph.view.translate;
								let tx = (x + tr.x) * s;
								let ty = (y + tr.y) * s;

								for (let i = 0; i < select.length; i++) {
									layout.moveCell(select[i], tx, ty);
								}
							}
						}

						if (removeLabel) {
							//let userData = ui.getCellValueAsXml(select);
							//userData.removeAttribute("label");
							//graph.getModel().setValue(select, userData);
							select[0].value.setAttribute('label', '');
						}

						if (realStyle) {
							graph.getModel().setStyle(select[0], realStyle);
						}

						if (allowCellsInserted) {
							graph.fireEvent(new mxEventObject('cellsInserted', 'cells', select));
						}
					} finally {
						graph.model.endUpdate();
					}

					if (select != null && select.length > 0) {
						graph.scrollCellToVisible(select[0]);
						graph.setSelectionCells(select);
					}
				}
			}

			mxEvent.consume(evt);
		}
	});
};

/**
 * Creates and returns a preview element for the given width and height.
 */
Sidebar.prototype.createDragPreview = function (width, height) {
	let elt = document.createElement('div');
	elt.style.border = '1px dashed black';
	elt.style.width = width + 'px';
	elt.style.height = height + 'px';

	return elt;
};

/**
 * Creates a drag source for the given element.
 */
Sidebar.prototype.dropAndConnect = function (source, targets, direction, dropCellIndex) {
	let geo = this.getDropAndConnectGeometry(source, targets[dropCellIndex], direction, targets);

	// Targets without the new edge for selection
	let tmp = [];

	if (geo != null) {
		let graph = this.editorUi.editor.graph;

		graph.model.beginUpdate();
		try {
			let sourceGeo = graph.getCellGeometry(source);
			let geo2 = graph.getCellGeometry(targets[dropCellIndex]);

			// Handles special case where target should be ignored for stack layouts
			let targetParent = graph.model.getParent(source);
			let validLayout = true;

			// Ignores parent if it has a stack layout
			if (graph.layoutManager != null) {
				let layout = graph.layoutManager.getLayout(targetParent);

				// LATER: Use parent of parent if valid layout
				if (layout != null && layout.constructor == mxStackLayout) {
					validLayout = false;

					let tmp = graph.view.getState(targetParent);

					// Offsets by parent position
					if (tmp != null) {
						let offset = new mxPoint(
							tmp.x / graph.view.scale - graph.view.translate.x,
							tmp.y / graph.view.scale - graph.view.translate.y,
						);
						geo.x += offset.x;
						geo.y += offset.y;
						let pt = geo.getTerminalPoint(false);

						if (pt != null) {
							pt.x += offset.x;
							pt.y += offset.y;
						}
					}
				}
			}

			let dx = geo2.x;
			let dy = geo2.y;

			// Ignores geometry of edges
			if (graph.model.isEdge(targets[dropCellIndex])) {
				dx = 0;
				dy = 0;
			}

			let useParent = graph.model.isEdge(source) || (sourceGeo != null && !sourceGeo.relative && validLayout);
			targets = graph.importCells(
				targets,
				geo.x - (useParent ? dx : 0),
				geo.y - (useParent ? dy : 0),
				useParent ? targetParent : null,
			);
			tmp = targets;

			if (graph.model.isEdge(source)) {
				// Adds new terminal to edge
				// LATER: Push new terminal out radially from edge start point
				graph.model.setTerminal(source, targets[dropCellIndex], direction == mxConstants.DIRECTION_NORTH);
			} else if (graph.model.isEdge(targets[dropCellIndex])) {
				// Adds new outgoing connection to vertex and clears points
				graph.model.setTerminal(targets[dropCellIndex], source, true);
				let geo3 = graph.getCellGeometry(targets[dropCellIndex]);
				geo3.points = null;

				if (geo3.getTerminalPoint(false) != null) {
					geo3.setTerminalPoint(geo.getTerminalPoint(false), false);
				} else if (useParent && graph.model.isVertex(targetParent)) {
					// Adds parent offset to other nodes
					let tmpState = graph.view.getState(targetParent);
					let offset = new mxPoint(
						tmpState.x / graph.view.scale - graph.view.translate.x,
						tmpState.y / graph.view.scale - graph.view.translate.y,
					);
					graph.cellsMoved(targets, offset.x, offset.y, null, null, true);
				}
			} else {
				geo2 = graph.getCellGeometry(targets[dropCellIndex]);
				dx = geo.x - Math.round(geo2.x);
				dy = geo.y - Math.round(geo2.y);
				geo.x = Math.round(geo2.x);
				geo.y = Math.round(geo2.y);
				graph.model.setGeometry(targets[dropCellIndex], geo);
				graph.cellsMoved(targets, dx, dy, null, null, true);
				tmp = targets.slice();
				targets.push(graph.insertEdge(null, null, '', source, targets[dropCellIndex], graph.createCurrentEdgeStyle()));
			}

			graph.fireEvent(new mxEventObject('cellsInserted', 'cells', targets));
		} finally {
			graph.model.endUpdate();
		}
	}

	return tmp;
};

/**
 * Creates a drag source for the given element.
 */
Sidebar.prototype.getDropAndConnectGeometry = function (source, target, direction, targets) {
	let graph = this.editorUi.editor.graph;
	let view = graph.view;
	let keepSize = targets.length > 1;
	let geo = graph.getCellGeometry(source);
	let geo2 = graph.getCellGeometry(target);

	if (geo != null && geo2 != null) {
		geo2 = geo2.clone();

		if (graph.model.isEdge(source)) {
			let state = graph.view.getState(source);
			let pts = state.absolutePoints;
			let p0 = pts[0];
			let pe = pts[pts.length - 1];

			if (direction == mxConstants.DIRECTION_NORTH) {
				geo2.x = p0.x / view.scale - view.translate.x - geo2.width / 2;
				geo2.y = p0.y / view.scale - view.translate.y - geo2.height / 2;
			} else {
				geo2.x = pe.x / view.scale - view.translate.x - geo2.width / 2;
				geo2.y = pe.y / view.scale - view.translate.y - geo2.height / 2;
			}
		} else {
			if (geo.relative) {
				let state = graph.view.getState(source);
				geo = geo.clone();
				geo.x = (state.x - view.translate.x) / view.scale;
				geo.y = (state.y - view.translate.y) / view.scale;
			}

			let length = graph.defaultEdgeLength;

			// Maintains edge length
			if (graph.model.isEdge(target) && geo2.getTerminalPoint(true) != null && geo2.getTerminalPoint(false) != null) {
				let p0 = geo2.getTerminalPoint(true);
				let pe = geo2.getTerminalPoint(false);
				let dx = pe.x - p0.x;
				let dy = pe.y - p0.y;

				length = Math.sqrt(dx * dx + dy * dy);

				geo2.x = geo.getCenterX();
				geo2.y = geo.getCenterY();
				geo2.width = 1;
				geo2.height = 1;

				if (direction == mxConstants.DIRECTION_NORTH) {
					geo2.height = length;
					geo2.y = geo.y - length;
					geo2.setTerminalPoint(new mxPoint(geo2.x, geo2.y), false);
				} else if (direction == mxConstants.DIRECTION_EAST) {
					geo2.width = length;
					geo2.x = geo.x + geo.width;
					geo2.setTerminalPoint(new mxPoint(geo2.x + geo2.width, geo2.y), false);
				} else if (direction == mxConstants.DIRECTION_SOUTH) {
					geo2.height = length;
					geo2.y = geo.y + geo.height;
					geo2.setTerminalPoint(new mxPoint(geo2.x, geo2.y + geo2.height), false);
				} else if (direction == mxConstants.DIRECTION_WEST) {
					geo2.width = length;
					geo2.x = geo.x - length;
					geo2.setTerminalPoint(new mxPoint(geo2.x, geo2.y), false);
				}
			} else {
				// Try match size or ignore if width or height < 45 which
				// is considered special enough to be ignored here
				if (!keepSize && geo2.width > 45 && geo2.height > 45 && geo.width > 45 && geo.height > 45) {
					geo2.width = geo2.width * (geo.height / geo2.height);
					geo2.height = geo.height;
				}

				geo2.x = geo.x + geo.width / 2 - geo2.width / 2;
				geo2.y = geo.y + geo.height / 2 - geo2.height / 2;

				if (direction == mxConstants.DIRECTION_NORTH) {
					geo2.y = geo2.y - geo.height / 2 - geo2.height / 2 - length;
				} else if (direction == mxConstants.DIRECTION_EAST) {
					geo2.x = geo2.x + geo.width / 2 + geo2.width / 2 + length;
				} else if (direction == mxConstants.DIRECTION_SOUTH) {
					geo2.y = geo2.y + geo.height / 2 + geo2.height / 2 + length;
				} else if (direction == mxConstants.DIRECTION_WEST) {
					geo2.x = geo2.x - geo.width / 2 - geo2.width / 2 - length;
				}

				// Adds offset to match cells without connecting edge
				if (graph.model.isEdge(target) && geo2.getTerminalPoint(true) != null && target.getTerminal(false) != null) {
					let targetGeo = graph.getCellGeometry(target.getTerminal(false));

					if (targetGeo != null) {
						if (direction == mxConstants.DIRECTION_NORTH) {
							geo2.x -= targetGeo.getCenterX();
							geo2.y -= targetGeo.getCenterY() + targetGeo.height / 2;
						} else if (direction == mxConstants.DIRECTION_EAST) {
							geo2.x -= targetGeo.getCenterX() - targetGeo.width / 2;
							geo2.y -= targetGeo.getCenterY();
						} else if (direction == mxConstants.DIRECTION_SOUTH) {
							geo2.x -= targetGeo.getCenterX();
							geo2.y -= targetGeo.getCenterY() - targetGeo.height / 2;
						} else if (direction == mxConstants.DIRECTION_WEST) {
							geo2.x -= targetGeo.getCenterX() + targetGeo.width / 2;
							geo2.y -= targetGeo.getCenterY();
						}
					}
				}
			}
		}
	}

	return geo2;
};

/**
 * Creates a drag source for the given element.
 */
Sidebar.prototype.createDragSource = function (elt, dropHandler, preview, cells, bounds) {
	// Checks if the cells contain any vertices
	let ui = this.editorUi;
	let graph = ui.editor.graph;
	let freeSourceEdge = null;
	let firstVertex = null;
	let sidebar = this;

	for (let i = 0; i < cells.length; i++) {
		if (firstVertex == null && this.editorUi.editor.graph.model.isVertex(cells[i])) {
			firstVertex = i;
		} else if (
			freeSourceEdge == null &&
			this.editorUi.editor.graph.model.isEdge(cells[i]) &&
			this.editorUi.editor.graph.model.getTerminal(cells[i], true) == null
		) {
			freeSourceEdge = i;
		}

		if (firstVertex != null && freeSourceEdge != null) {
			break;
		}
	}

	let dragSource = mxUtils.makeDraggable(
		elt,
		this.editorUi.editor.graph,
		mxUtils.bind(this, function (graph, evt, target, x, y) {
			if (this.updateThread != null) {
				window.clearTimeout(this.updateThread);
			}

			if (cells != null && currentStyleTarget != null && activeArrow == styleTarget) {
				let tmp = graph.isCellSelected(currentStyleTarget.cell) ? graph.getSelectionCells() : [currentStyleTarget.cell];
				let updatedCells = this.updateShapes(
					graph.model.isEdge(currentStyleTarget.cell) ? cells[0] : cells[firstVertex],
					tmp,
				);
				graph.setSelectionCells(updatedCells);
			} else if (cells != null && activeArrow != null && currentTargetState != null && activeArrow != styleTarget) {
				let index =
					graph.model.isEdge(currentTargetState.cell) || freeSourceEdge == null ? firstVertex : freeSourceEdge;
				graph.setSelectionCells(this.dropAndConnect(currentTargetState.cell, cells, direction, index));
			} else {
				dropHandler.apply(this, arguments);
			}

			if (this.editorUi.hoverIcons != null) {
				this.editorUi.hoverIcons.update(graph.view.getState(graph.getSelectionCell()));
			}
		}),
		preview,
		0,
		0,
		this.editorUi.editor.graph.autoscroll,
		true,
		true,
	);

	// Stops dragging if cancel is pressed
	this.editorUi.editor.graph.addListener(mxEvent.ESCAPE, function (sender, evt) {
		if (dragSource.isActive()) {
			dragSource.reset();
		}
	});

	// Overrides mouseDown to ignore popup triggers
	let mouseDown = dragSource.mouseDown;

	dragSource.mouseDown = function (evt) {
		if (!mxEvent.isPopupTrigger(evt) && !mxEvent.isMultiTouchEvent(evt)) {
			graph.stopEditing();
			mouseDown.apply(this, arguments);
		}
	};

	// Workaround for event redirection via image tag in quirks and IE8
	function createArrow(img, tooltip) {
		let arrow = null;

		if (mxClient.IS_IE && !mxClient.IS_SVG) {
			// Workaround for PNG images in IE6
			if (mxClient.IS_IE6 && document.compatMode != 'CSS1Compat') {
				arrow = document.createElement(mxClient.VML_PREFIX + ':image');
				arrow.setAttribute('src', img.src);
				arrow.style.borderStyle = 'none';
			} else {
				arrow = document.createElement('div');
				arrow.style.backgroundImage = 'url(' + img.src + ')';
				arrow.style.backgroundPosition = 'center';
				arrow.style.backgroundRepeat = 'no-repeat';
			}

			arrow.style.width = img.width + 4 + 'px';
			arrow.style.height = img.height + 4 + 'px';
			arrow.style.display = mxClient.IS_QUIRKS ? 'inline' : 'inline-block';
		} else {
			arrow = mxUtils.createImage(img.src);
			arrow.style.width = img.width + 'px';
			arrow.style.height = img.height + 'px';
		}

		if (tooltip != null) {
			arrow.setAttribute('title', tooltip);
		}

		mxUtils.setOpacity(arrow, 20);
		arrow.style.position = 'absolute';
		arrow.style.cursor = 'crosshair';

		return arrow;
	}

	let currentTargetState = null;
	let currentStateHandle = null;
	let currentStyleTarget = null;
	let activeTarget = false;

	let arrowUp = createArrow(this.triangleUp, mxResources.get('connect'));
	let arrowRight = createArrow(this.triangleRight, mxResources.get('connect'));
	let arrowDown = createArrow(this.triangleDown, mxResources.get('connect'));
	let arrowLeft = createArrow(this.triangleLeft, mxResources.get('connect'));
	let styleTarget = createArrow(this.refreshTarget, mxResources.get('replace'));
	// Workaround for actual parentNode not being updated in old IE
	let styleTargetParent = null;
	let roundSource = createArrow(this.roundDrop);
	let roundTarget = createArrow(this.roundDrop);
	let direction = mxConstants.DIRECTION_NORTH;
	let activeArrow = null;

	function checkArrow(x, y, bounds, arrow) {
		if (arrow.parentNode != null) {
			if (mxUtils.contains(bounds, x, y)) {
				mxUtils.setOpacity(arrow, 100);
				activeArrow = arrow;
			} else {
				mxUtils.setOpacity(arrow, arrow == styleTarget ? 30 : 20);
			}
		}

		return bounds;
	}

	// Hides guides and preview if target is active
	let dsCreatePreviewElement = dragSource.createPreviewElement;

	// Stores initial size of preview element
	dragSource.createPreviewElement = function (graph) {
		let elt = dsCreatePreviewElement.apply(this, arguments);

		// Pass-through events required to tooltip on replace shape
		if (mxClient.IS_SVG) {
			elt.style.pointerEvents = 'none';
		}

		this.previewElementWidth = elt.style.width;
		this.previewElementHeight = elt.style.height;

		return elt;
	};

	// Shows/hides hover icons
	let dragEnter = dragSource.dragEnter;
	dragSource.dragEnter = function (graph, evt) {
		if (ui.hoverIcons != null) {
			ui.hoverIcons.setDisplay('none');
		}

		dragEnter.apply(this, arguments);
	};

	let dragExit = dragSource.dragExit;
	dragSource.dragExit = function (graph, evt) {
		if (ui.hoverIcons != null) {
			ui.hoverIcons.setDisplay('');
		}

		dragExit.apply(this, arguments);
	};

	dragSource.dragOver = function (graph, evt) {
		mxDragSource.prototype.dragOver.apply(this, arguments);

		if (this.currentGuide != null && activeArrow != null) {
			this.currentGuide.hide();
		}

		if (this.previewElement != null) {
			let view = graph.view;

			if (currentStyleTarget != null && activeArrow == styleTarget) {
				this.previewElement.style.display = graph.model.isEdge(currentStyleTarget.cell) ? 'none' : '';

				this.previewElement.style.left = currentStyleTarget.x + 'px';
				this.previewElement.style.top = currentStyleTarget.y + 'px';
				this.previewElement.style.width = currentStyleTarget.width + 'px';
				this.previewElement.style.height = currentStyleTarget.height + 'px';
			} else if (currentTargetState != null && activeArrow != null) {
				let index =
					graph.model.isEdge(currentTargetState.cell) || freeSourceEdge == null ? firstVertex : freeSourceEdge;
				let geo = sidebar.getDropAndConnectGeometry(currentTargetState.cell, cells[index], direction, cells);
				let geo2 = !graph.model.isEdge(currentTargetState.cell) ? graph.getCellGeometry(currentTargetState.cell) : null;
				let geo3 = graph.getCellGeometry(cells[index]);
				let parent = graph.model.getParent(currentTargetState.cell);
				let dx = view.translate.x * view.scale;
				let dy = view.translate.y * view.scale;

				if (geo2 != null && !geo2.relative && graph.model.isVertex(parent)) {
					let pState = view.getState(parent);
					dx = pState.x;
					dy = pState.y;
				}

				let dx2 = geo3.x;
				let dy2 = geo3.y;

				// Ignores geometry of edges
				if (graph.model.isEdge(cells[index])) {
					dx2 = 0;
					dy2 = 0;
				}

				// Shows preview at drop location
				this.previewElement.style.left = (geo.x - dx2) * view.scale + dx + 'px';
				this.previewElement.style.top = (geo.y - dy2) * view.scale + dy + 'px';

				if (cells.length == 1) {
					this.previewElement.style.width = geo.width * view.scale + 'px';
					this.previewElement.style.height = geo.height * view.scale + 'px';
				}

				this.previewElement.style.display = '';
			} else if (
				dragSource.currentHighlight.state != null &&
				graph.model.isEdge(dragSource.currentHighlight.state.cell)
			) {
				// Centers drop cells when splitting edges
				this.previewElement.style.left =
					Math.round(parseInt(this.previewElement.style.left) - (bounds.width * view.scale) / 2) + 'px';
				this.previewElement.style.top =
					Math.round(parseInt(this.previewElement.style.top) - (bounds.height * view.scale) / 2) + 'px';
			} else {
				this.previewElement.style.width = this.previewElementWidth;
				this.previewElement.style.height = this.previewElementHeight;
				this.previewElement.style.display = '';
			}
		}
	};

	let startTime = new Date().getTime();
	let timeOnTarget = 0;
	let prev = null;

	// Gets source cell style to compare shape below
	let sourceCellStyle = this.editorUi.editor.graph.getCellStyle(cells[0]);

	// Allows drop into cell only if target is a valid root
	dragSource.getDropTarget = mxUtils.bind(this, function (graph, x, y, evt) {
		// Alt means no targets at all
		// LATER: Show preview where result will go
		let cell = !mxEvent.isAltDown(evt) && cells != null ? graph.getCellAt(x, y) : null;

		// Uses connectable parent vertex if one exists
		if (cell != null && !this.graph.isCellConnectable(cell)) {
			let parent = this.graph.getModel().getParent(cell);

			if (this.graph.getModel().isVertex(parent) && this.graph.isCellConnectable(parent)) {
				cell = parent;
			}
		}

		// Ignores locked cells
		if (graph.isCellLocked(cell)) {
			cell = null;
		}

		let state = graph.view.getState(cell);
		activeArrow = null;
		let bbox = null;

		// Time on target
		if (prev != state) {
			prev = state;
			startTime = new Date().getTime();
			timeOnTarget = 0;

			if (this.updateThread != null) {
				window.clearTimeout(this.updateThread);
			}

			if (state != null) {
				this.updateThread = window.setTimeout(function () {
					if (activeArrow == null) {
						prev = state;
						dragSource.getDropTarget(graph, x, y, evt);
					}
				}, this.dropTargetDelay + 10);
			}
		} else {
			timeOnTarget = new Date().getTime() - startTime;
		}

		// Shift means disabled, delayed on cells with children, shows after this.dropTargetDelay, hides after 2500ms
		if (
			timeOnTarget < 2500 &&
			state != null &&
			!mxEvent.isShiftDown(evt) &&
			// If shape is equal or target has no stroke then add long delay except for images
			((mxUtils.getValue(state.style, mxConstants.STYLE_SHAPE) !=
				mxUtils.getValue(sourceCellStyle, mxConstants.STYLE_SHAPE) &&
				mxUtils.getValue(state.style, mxConstants.STYLE_STROKECOLOR, mxConstants.NONE) != mxConstants.NONE) ||
				mxUtils.getValue(sourceCellStyle, mxConstants.STYLE_SHAPE) == 'image' ||
				timeOnTarget > 1500 ||
				graph.model.isEdge(state.cell)) &&
			timeOnTarget > this.dropTargetDelay &&
			((graph.model.isVertex(state.cell) && firstVertex != null) ||
				(graph.model.isEdge(state.cell) && graph.model.isEdge(cells[0])))
		) {
			currentStyleTarget = state;
			let tmp = graph.model.isEdge(state.cell)
				? graph.view.getPoint(state)
				: new mxPoint(state.getCenterX(), state.getCenterY());
			tmp = new mxRectangle(
				tmp.x - this.refreshTarget.width / 2,
				tmp.y - this.refreshTarget.height / 2,
				this.refreshTarget.width,
				this.refreshTarget.height,
			);

			styleTarget.style.left = Math.floor(tmp.x) + 'px';
			styleTarget.style.top = Math.floor(tmp.y) + 'px';

			if (styleTargetParent == null) {
				graph.container.appendChild(styleTarget);
				styleTargetParent = styleTarget.parentNode;
			}

			checkArrow(x, y, tmp, styleTarget);
		}
		// Does not reset on ignored edges
		else if (
			currentStyleTarget == null ||
			!mxUtils.contains(currentStyleTarget, x, y) ||
			(timeOnTarget > 1500 && !mxEvent.isShiftDown(evt))
		) {
			currentStyleTarget = null;

			if (styleTargetParent != null) {
				styleTarget.parentNode.removeChild(styleTarget);
				styleTargetParent = null;
			}
		} else if (currentStyleTarget != null && styleTargetParent != null) {
			// Sets active Arrow as side effect
			let tmp = graph.model.isEdge(currentStyleTarget.cell)
				? graph.view.getPoint(currentStyleTarget)
				: new mxPoint(currentStyleTarget.getCenterX(), currentStyleTarget.getCenterY());
			tmp = new mxRectangle(
				tmp.x - this.refreshTarget.width / 2,
				tmp.y - this.refreshTarget.height / 2,
				this.refreshTarget.width,
				this.refreshTarget.height,
			);
			checkArrow(x, y, tmp, styleTarget);
		}

		// Checks if inside bounds
		if (activeTarget && currentTargetState != null && !mxEvent.isAltDown(evt) && activeArrow == null) {
			// LATER: Use hit-detection for edges
			bbox = mxRectangle.fromRectangle(currentTargetState);

			if (graph.model.isEdge(currentTargetState.cell)) {
				let pts = currentTargetState.absolutePoints;

				if (roundSource.parentNode != null) {
					let p0 = pts[0];
					bbox.add(
						checkArrow(
							x,
							y,
							new mxRectangle(
								p0.x - this.roundDrop.width / 2,
								p0.y - this.roundDrop.height / 2,
								this.roundDrop.width,
								this.roundDrop.height,
							),
							roundSource,
						),
					);
				}

				if (roundTarget.parentNode != null) {
					let pe = pts[pts.length - 1];
					bbox.add(
						checkArrow(
							x,
							y,
							new mxRectangle(
								pe.x - this.roundDrop.width / 2,
								pe.y - this.roundDrop.height / 2,
								this.roundDrop.width,
								this.roundDrop.height,
							),
							roundTarget,
						),
					);
				}
			} else {
				let bds = mxRectangle.fromRectangle(currentTargetState);

				// Uses outer bounding box to take rotation into account
				if (currentTargetState.shape != null && currentTargetState.shape.boundingBox != null) {
					bds = mxRectangle.fromRectangle(currentTargetState.shape.boundingBox);
				}

				bds.grow(this.graph.tolerance);
				bds.grow(HoverIcons.prototype.arrowSpacing);

				let handler = this.graph.selectionCellsHandler.getHandler(currentTargetState.cell);

				if (handler != null) {
					bds.x -= handler.horizontalOffset / 2;
					bds.y -= handler.verticalOffset / 2;
					bds.width += handler.horizontalOffset;
					bds.height += handler.verticalOffset;

					// Adds bounding box of rotation handle to avoid overlap
					if (
						handler.rotationShape != null &&
						handler.rotationShape.node != null &&
						handler.rotationShape.node.style.visibility != 'hidden' &&
						handler.rotationShape.node.style.display != 'none' &&
						handler.rotationShape.boundingBox != null
					) {
						bds.add(handler.rotationShape.boundingBox);
					}
				}

				bbox.add(
					checkArrow(
						x,
						y,
						new mxRectangle(
							currentTargetState.getCenterX() - this.triangleUp.width / 2,
							bds.y - this.triangleUp.height,
							this.triangleUp.width,
							this.triangleUp.height,
						),
						arrowUp,
					),
				);
				bbox.add(
					checkArrow(
						x,
						y,
						new mxRectangle(
							bds.x + bds.width,
							currentTargetState.getCenterY() - this.triangleRight.height / 2,
							this.triangleRight.width,
							this.triangleRight.height,
						),
						arrowRight,
					),
				);
				bbox.add(
					checkArrow(
						x,
						y,
						new mxRectangle(
							currentTargetState.getCenterX() - this.triangleDown.width / 2,
							bds.y + bds.height,
							this.triangleDown.width,
							this.triangleDown.height,
						),
						arrowDown,
					),
				);
				bbox.add(
					checkArrow(
						x,
						y,
						new mxRectangle(
							bds.x - this.triangleLeft.width,
							currentTargetState.getCenterY() - this.triangleLeft.height / 2,
							this.triangleLeft.width,
							this.triangleLeft.height,
						),
						arrowLeft,
					),
				);
			}

			// Adds tolerance
			if (bbox != null) {
				bbox.grow(10);
			}
		}

		direction = mxConstants.DIRECTION_NORTH;

		if (activeArrow == arrowRight) {
			direction = mxConstants.DIRECTION_EAST;
		} else if (activeArrow == arrowDown || activeArrow == roundTarget) {
			direction = mxConstants.DIRECTION_SOUTH;
		} else if (activeArrow == arrowLeft) {
			direction = mxConstants.DIRECTION_WEST;
		}

		if (currentStyleTarget != null && activeArrow == styleTarget) {
			state = currentStyleTarget;
		}

		let validTarget =
			(firstVertex == null || graph.isCellConnectable(cells[firstVertex])) &&
			((graph.model.isEdge(cell) && firstVertex != null) ||
				(graph.model.isVertex(cell) && graph.isCellConnectable(cell)));

		// Drop arrows shown after this.dropTargetDelay, hidden after 5 secs, switches arrows after 500ms
		if (
			(currentTargetState != null && timeOnTarget >= 5000) ||
			(currentTargetState != state &&
				(bbox == null || !mxUtils.contains(bbox, x, y) || (timeOnTarget > 500 && activeArrow == null && validTarget)))
		) {
			activeTarget = false;
			currentTargetState =
				(timeOnTarget < 5000 && timeOnTarget > this.dropTargetDelay) || graph.model.isEdge(cell) ? state : null;

			if (currentTargetState != null && validTarget) {
				let elts = [roundSource, roundTarget, arrowUp, arrowRight, arrowDown, arrowLeft];

				for (let i = 0; i < elts.length; i++) {
					if (elts[i].parentNode != null) {
						elts[i].parentNode.removeChild(elts[i]);
					}
				}

				if (graph.model.isEdge(cell)) {
					let pts = state.absolutePoints;

					if (pts != null) {
						let p0 = pts[0];
						let pe = pts[pts.length - 1];
						let tol = graph.tolerance;
						let box = new mxRectangle(x - tol, y - tol, 2 * tol, 2 * tol);

						roundSource.style.left = Math.floor(p0.x - this.roundDrop.width / 2) + 'px';
						roundSource.style.top = Math.floor(p0.y - this.roundDrop.height / 2) + 'px';

						roundTarget.style.left = Math.floor(pe.x - this.roundDrop.width / 2) + 'px';
						roundTarget.style.top = Math.floor(pe.y - this.roundDrop.height / 2) + 'px';

						if (graph.model.getTerminal(cell, true) == null) {
							graph.container.appendChild(roundSource);
						}

						if (graph.model.getTerminal(cell, false) == null) {
							graph.container.appendChild(roundTarget);
						}
					}
				} else {
					let bds = mxRectangle.fromRectangle(state);

					// Uses outer bounding box to take rotation into account
					if (state.shape != null && state.shape.boundingBox != null) {
						bds = mxRectangle.fromRectangle(state.shape.boundingBox);
					}

					bds.grow(this.graph.tolerance);
					bds.grow(HoverIcons.prototype.arrowSpacing);

					let handler = this.graph.selectionCellsHandler.getHandler(state.cell);

					if (handler != null) {
						bds.x -= handler.horizontalOffset / 2;
						bds.y -= handler.verticalOffset / 2;
						bds.width += handler.horizontalOffset;
						bds.height += handler.verticalOffset;

						// Adds bounding box of rotation handle to avoid overlap
						if (
							handler.rotationShape != null &&
							handler.rotationShape.node != null &&
							handler.rotationShape.node.style.visibility != 'hidden' &&
							handler.rotationShape.node.style.display != 'none' &&
							handler.rotationShape.boundingBox != null
						) {
							bds.add(handler.rotationShape.boundingBox);
						}
					}

					arrowUp.style.left = Math.floor(state.getCenterX() - this.triangleUp.width / 2) + 'px';
					arrowUp.style.top = Math.floor(bds.y - this.triangleUp.height) + 'px';

					arrowRight.style.left = Math.floor(bds.x + bds.width) + 'px';
					arrowRight.style.top = Math.floor(state.getCenterY() - this.triangleRight.height / 2) + 'px';

					arrowDown.style.left = arrowUp.style.left;
					arrowDown.style.top = Math.floor(bds.y + bds.height) + 'px';

					arrowLeft.style.left = Math.floor(bds.x - this.triangleLeft.width) + 'px';
					arrowLeft.style.top = arrowRight.style.top;

					if (state.style['portConstraint'] != 'eastwest') {
						graph.container.appendChild(arrowUp);
						graph.container.appendChild(arrowDown);
					}

					graph.container.appendChild(arrowRight);
					graph.container.appendChild(arrowLeft);
				}

				// Hides handle for cell under mouse
				if (state != null) {
					currentStateHandle = graph.selectionCellsHandler.getHandler(state.cell);

					if (currentStateHandle != null && currentStateHandle.setHandlesVisible != null) {
						currentStateHandle.setHandlesVisible(false);
					}
				}

				activeTarget = true;
			} else {
				let elts = [roundSource, roundTarget, arrowUp, arrowRight, arrowDown, arrowLeft];

				for (let i = 0; i < elts.length; i++) {
					if (elts[i].parentNode != null) {
						elts[i].parentNode.removeChild(elts[i]);
					}
				}
			}
		}

		if (!activeTarget && currentStateHandle != null) {
			currentStateHandle.setHandlesVisible(true);
		}

		// Handles drop target
		let target =
			(!mxEvent.isAltDown(evt) || mxEvent.isShiftDown(evt)) &&
			!(currentStyleTarget != null && activeArrow == styleTarget)
				? mxDragSource.prototype.getDropTarget.apply(this, arguments)
				: null;
		let model = graph.getModel();

		if (target != null) {
			if (activeArrow != null || !graph.isSplitTarget(target, cells, evt)) {
				// Selects parent group as drop target
				while (
					target != null &&
					!graph.isValidDropTarget(target, cells, evt) &&
					model.isVertex(model.getParent(target))
				) {
					target = model.getParent(target);
				}

				if (
					graph.view.currentRoot == target ||
					(!graph.isValidRoot(target) && graph.getModel().getChildCount(target) == 0) ||
					graph.isCellLocked(target) ||
					model.isEdge(target)
				) {
					target = null;
				}
			}
		}

		return target;
	});

	dragSource.stopDrag = function () {
		mxDragSource.prototype.stopDrag.apply(this, arguments);

		let elts = [roundSource, roundTarget, styleTarget, arrowUp, arrowRight, arrowDown, arrowLeft];

		for (let i = 0; i < elts.length; i++) {
			if (elts[i].parentNode != null) {
				elts[i].parentNode.removeChild(elts[i]);
			}
		}

		if (currentTargetState != null && currentStateHandle != null) {
			currentStateHandle.reset();
		}

		currentStateHandle = null;
		currentTargetState = null;
		currentStyleTarget = null;
		styleTargetParent = null;
		activeArrow = null;
	};

	return dragSource;
};

/**
 * Adds a handler for inserting the cell with a single click.
 */
Sidebar.prototype.itemClicked = function (cells, ds, evt, elt) {
	let graph = this.editorUi.editor.graph;
	let handled = false;

	if (cells != null && graph.getSelectionCount() == 1 && graph.getModel().isVertex(cells[0])) {
		let target = graph.cloneCells(cells)[0];

		// Inserts cell as target of selected edge if not connected
		if (
			graph.getModel().isEdge(graph.getSelectionCell()) &&
			graph.getModel().getTerminal(graph.getSelectionCell(), false) == null &&
			graph.getModel().isVertex(target)
		) {
			graph.getModel().beginUpdate();
			try {
				let edgeState = graph.view.getState(graph.getSelectionCell());

				if (edgeState != null) {
					let tr = graph.view.translate;
					let s = graph.view.scale;
					let pt = edgeState.absolutePoints[edgeState.absolutePoints.length - 1];

					target.geometry.x = pt.x / s - tr.x - target.geometry.width / 2;
					target.geometry.y = pt.y / s - tr.y - target.geometry.height / 2;
				}

				graph.addCell(target);
				graph.getModel().setTerminal(graph.getSelectionCell(), target, false);
			} finally {
				graph.getModel().endUpdate();
			}

			graph.scrollCellToVisible(target);
			graph.setSelectionCell(target);
			handled = true;
		}
	}

	if (handled) return;

	// Alt+Click inserts and connects
	if (mxEvent.isAltDown(evt)) {
		if (graph.getSelectionCount() == 1 && graph.model.isVertex(graph.getSelectionCell())) {
			let firstVertex = null;

			for (let i = 0; i < cells.length && firstVertex == null; i++) {
				if (graph.model.isVertex(cells[i])) {
					firstVertex = i;
				}
			}

			if (firstVertex != null) {
				graph.setSelectionCells(
					this.dropAndConnect(
						graph.getSelectionCell(),
						cells,
						mxEvent.isMetaDown(evt) || mxEvent.isControlDown(evt)
							? mxEvent.isShiftDown(evt)
								? mxConstants.DIRECTION_WEST
								: mxConstants.DIRECTION_NORTH
							: mxEvent.isShiftDown(evt)
								? mxConstants.DIRECTION_EAST
								: mxConstants.DIRECTION_SOUTH,
						firstVertex,
					),
				);
				graph.scrollCellToVisible(graph.getSelectionCell());
			}
		}
	}
	// Shift+Click updates shape
	else if (mxEvent.isShiftDown(evt)) {
		if (!graph.isSelectionEmpty()) {
			this.updateShapes(cells[0], graph.getSelectionCells());
			graph.scrollCellToVisible(graph.getSelectionCell());
		}
	} else {
		let pt = graph.getFreeInsertPoint();
		ds.drop(graph, evt, null, pt.x, pt.y);

		if (this.editorUi.hoverIcons != null && mxEvent.isTouchEvent(evt)) {
			this.editorUi.hoverIcons.update(graph.view.getState(graph.getSelectionCell()));
		}
	}
};

/**
 * Adds a handler for inserting the cell with a single click.
 */
Sidebar.prototype.addClickHandler = function (elt, ds, cells) {
	let graph = this.editorUi.editor.graph;
	let oldMouseUp = ds.mouseUp;
	let first = null;

	mxEvent.addGestureListeners(elt, function (evt) {
		first = new mxPoint(mxEvent.getClientX(evt), mxEvent.getClientY(evt));
	});

	ds.mouseUp = mxUtils.bind(this, function (evt) {
		if (!mxEvent.isPopupTrigger(evt) && this.currentGraph == null && first != null) {
			let tol = graph.tolerance;

			if (Math.abs(first.x - mxEvent.getClientX(evt)) <= tol && Math.abs(first.y - mxEvent.getClientY(evt)) <= tol) {
				this.itemClicked(cells, ds, evt, elt);
			}
		}

		oldMouseUp.apply(ds, arguments);
		first = null;

		// Blocks tooltips on this element after single click
		this.currentElt = elt;
	});
};

/**
 * Creates a drop handler for inserting the given cells.
 */
Sidebar.prototype.createVertexTemplateFromData = function (
	data,
	width,
	height,
	title,
	showLabel,
	showTitle,
	allowCellsInserted,
) {
	let doc = mxUtils.parseXml(this.graph.decompress(data));
	let codec = new mxCodec(doc);

	let model = new mxGraphModel();
	codec.decode(doc.documentElement, model);

	let cells = this.graph.cloneCells(model.root.getChildAt(0).children);

	return this.createVertexTemplateFromCells(cells, width, height, title, showLabel, showTitle, allowCellsInserted);
};

/**
 * Creates a drop handler for inserting the given cells.
 */
Sidebar.prototype.createVertexTemplateFromCells = function (
	cells,
	width,
	height,
	title,
	showLabel,
	showTitle,
	allowCellsInserted,
) {
	return this.createItem(cells, title, showLabel, showTitle, width, height, allowCellsInserted);
};

/**
 *
 */
Sidebar.prototype.createEdgeTemplateEntry = function (
	style,
	width,
	height,
	value,
	title,
	showLabel,
	tags,
	allowCellsInserted,
) {
	tags = tags != null && tags.length > 0 ? tags : title.toLowerCase();

	return this.addEntry(
		tags,
		mxUtils.bind(this, function () {
			return this.createEdgeTemplate(style, width, height, value, title, showLabel, allowCellsInserted);
		}),
	);
};

/**
 * Creates a drop handler for inserting the given cells.
 */
Sidebar.prototype.createEdgeTemplate = function (style, width, height, value, title, showLabel, allowCellsInserted) {
	let cell = new mxCell(value != null ? value : '', new mxGeometry(0, 0, width, height), style);
	cell.geometry.setTerminalPoint(new mxPoint(0, height), true);
	cell.geometry.setTerminalPoint(new mxPoint(width, 0), false);
	cell.geometry.relative = true;
	cell.edge = true;

	return this.createEdgeTemplateFromCells([cell], width, height, title, showLabel, allowCellsInserted);
};

/**
 * Creates a drop handler for inserting the given cells.
 */
Sidebar.prototype.createEdgeTemplateFromCells = function (cells, width, height, title, showLabel, allowCellsInserted) {
	return this.createItem(cells, title, showLabel, true, width, height, allowCellsInserted);
};

/**
 * Adds the given palette.
 */
Sidebar.prototype.addPaletteFunctions = function (id, title, expanded, fns) {
	this.palettes.push({
		id: id,
		name: title,
		functions: fns,
	});
};

/**
 * Adds the given palette.
 */
Sidebar.prototype.addPalette = function (id, title, expanded, onInit) {
	this.palettes.push({
		id,
		name: title,
		callback: onInit,
	});
};

/**
 * Adds the given image palette.
 */
Sidebar.prototype.addImagePalette = function (id, title, prefix, postfix, items, titles, tags) {
	let showTitles = titles != null;
	let fns = [];

	for (let i = 0; i < items.length; i++) {
		mxUtils.bind(this, function (item, title, tmpTags) {
			if (tmpTags == null) {
				let slash = item.lastIndexOf('/');
				let dot = item.lastIndexOf('.');
				tmpTags = item.substring(slash >= 0 ? slash + 1 : 0, dot >= 0 ? dot : item.length).replace(/[-_]/g, ' ');
			}

			fns.push(
				this.createVertexTemplateEntry(
					'image;html=1;labelBackgroundColor=#ffffff;image=' + prefix + item + postfix,
					this.defaultImageWidth,
					this.defaultImageHeight,
					'',
					title,
					title != null,
					null,
					this.filterTags(tmpTags),
				),
			);
		})(items[i], titles != null ? titles[i] : null, tags != null ? tags[items[i]] : null);
	}

	this.addPaletteFunctions(id, title, false, fns);
};

/**
 * Creates the array of tags for the given stencil. Duplicates are allowed and will be filtered out later.
 */
Sidebar.prototype.getTagsForStencil = function (packageName, stencilName, moreTags) {
	let tags = packageName.split('.');

	for (let i = 1; i < tags.length; i++) {
		tags[i] = tags[i].replace(/_/g, ' ');
	}

	tags.push(stencilName.replace(/_/g, ' '));

	if (moreTags != null) {
		tags.push(moreTags);
	}

	tags = tags.slice(1, tags.length);
	// Adds tags from tags file
	if (this.shapetags != null) {
		packageName = packageName.toLowerCase();
		stencilName = stencilName.toLowerCase();

		if (this.shapetags[pkg] != null) {
			tags.push(this.shapetags[pkg]);
		}

		stencilName = packageName + '.' + stencilName;

		if (this.shapetags[stc] != null) {
			tags.push(this.shapetags[stc]);
		}
	}

	return tags;
};

/**
 * Adds the given stencil palette.
 */
Sidebar.prototype.addStencilPalette = function (id, title, stencilFile, style, ignore, onInit, scale, tags, customFns) {
	scale = scale != null ? scale : 1;

	if (this.addStencilsToIndex) {
		// LATER: Handle asynchronous loading dependency
		let fns = [];

		if (customFns != null) {
			for (let i = 0; i < customFns.length; i++) {
				fns.push(customFns[i]);
			}
		}

		mxStencilRegistry.loadStencilSet(
			stencilFile,
			mxUtils.bind(this, function (packageName, stencilName, displayName, w, h) {
				if (ignore == null || mxUtils.indexOf(ignore, stencilName) < 0) {
					let tmp = this.getTagsForStencil(packageName, stencilName);
					let tmpTags = tags != null ? tags[stencilName] : null;

					if (tmpTags != null) {
						tmp.push(tmpTags);
					}

					fns.push(
						this.createVertexTemplateEntry(
							'shape=' + packageName + stencilName.toLowerCase() + style,
							Math.round(w * scale),
							Math.round(h * scale),
							'',
							stencilName.replace(/_/g, ' '),
							null,
							null,
							this.filterTags(tmp.join(' ')),
						),
					);
				}
			}),
			true,
			true,
		);

		this.addPaletteFunctions(id, title, false, fns);
	} else {
		this.addPalette(
			id,
			title,
			false,
			mxUtils.bind(this, function (content, filterCallback) {
				if (style == null) {
					style = '';
				}

				if (onInit != null) {
					onInit.call(this, content);
				}

				if (customFns != null) {
					for (let i = 0; i < customFns.length; i++) {
						customFns[i](content);
					}
				}

				mxStencilRegistry.loadStencilSet(
					stencilFile,
					mxUtils.bind(this, function (packageName, stencilName, displayName, w, h) {
						if (ignore == null || mxUtils.indexOf(ignore, stencilName) < 0) {
							const title = stencilName.replace(/_/g, ' ');

							if (!filterCallback(title)) return;

							content.appendChild(
								this.createVertexTemplate(
									'shape=' + packageName + stencilName.toLowerCase() + style,
									Math.round(w * scale),
									Math.round(h * scale),
									'',
									title,
									true,
								),
							);
						}
					}),
					true,
				);
			}),
		);
	}
};

Sidebar.prototype.createVertexTemplateEntry = function (
	style,
	width,
	height,
	value,
	title,
	showLabel,
	showTitle,
	tags,
	contentFactory,
	removeLabel,
	realStyle,
) {
	tags = tags != null && tags.length > 0 ? tags : title.toLowerCase();

	//we decided not to use tags for search. Questions to Bernt :)
	return this.addEntry(
		title,
		mxUtils.bind(this, function () {
			let valueCopy = value;

			if (value.cloneNode) {
				valueCopy = value.cloneNode(true);
			}

			return this.createVertexTemplate(
				style,
				width,
				height,
				valueCopy,
				title,
				showLabel,
				showTitle,
				null,
				contentFactory,
				removeLabel,
				realStyle,
			);
		}),
	);
};

Sidebar.prototype.createVertexTemplate = function (
	style,
	width,
	height,
	value,
	title,
	showLabel,
	showTitle,
	allowCellsInserted,
	contentFactory,
	removeLabel,
	realStyle,
) {
	if (style.substr(-1) != ';') {
		style += ';';
	}

	if (style.indexOf('verticalLabelPosition') == -1) {
		style += 'verticalLabelPosition=bottom;';
	}
	if (style.indexOf('verticalAlign') == -1) {
		style += 'verticalAlign=top;';
	}
	var cells = [new mxCell(value != null ? value : '', new mxGeometry(0, 0, width, height), style)];
	cells[0].vertex = true;

	return this.createVertexTemplateFromCells(
		cells,
		width,
		height,
		title,
		showLabel,
		showTitle,
		allowCellsInserted,
		contentFactory,
		removeLabel,
		realStyle,
	);
};

Sidebar.prototype.createVertexTemplateFromCells = function (
	cells,
	width,
	height,
	title,
	showLabel,
	showTitle,
	allowCellsInserted,
	contentFactory,
	removeLabel,
	realStyle,
) {
	return this.createItem(
		cells,
		title,
		showLabel,
		showTitle,
		width,
		height,
		allowCellsInserted,
		contentFactory,
		removeLabel,
		realStyle,
	);
};

Sidebar.prototype.createItem = function (
	cells,
	title,
	showLabel,
	showTitle,
	width,
	height,
	allowCellsInserted,
	contentFactory,
	removeLabel,
	realStyle,
) {
	if (cells == null) {
		cells = null;
	}
	var elt = document.createElement('div');
	elt.className = 'designer-shapes-collection__shape';
	elt.style.overflow = 'hidden';
	var border = mxClient.IS_QUIRKS ? 8 + 2 * this.thumbPadding : 2 * this.thumbBorder;
	elt.style.width = this.thumbWidth + border + 'px';
	elt.style.height = this.thumbHeight + border + 'px';
	elt.style.padding = this.thumbPadding + 'px';
	elt.title = title;

	if (mxClient.IS_IE6) {
		elt.style.border = 'none';
	}

	// Blocks default click action
	mxEvent.addListener(elt, 'click', function (evt) {
		mxEvent.consume(evt);
	});

	if (contentFactory == null) {
		this.createThumb(cells, this.thumbWidth, this.thumbHeight, elt, title, showLabel, showTitle, width, height);
	} else contentFactory(elt);

	var bounds = new mxRectangle(0, 0, width, height);

	var ds = this.createDragSource(
		elt,
		this.createDropHandler(cells, true, allowCellsInserted, bounds, removeLabel, realStyle),
		this.createDragPreview(width, height),
		cells,
		bounds,
	);

	this.addClickHandler(elt, ds, cells);

	if (cells.length > 1 || cells[0].vertex) {
		// Uses guides for vertices only if enabled in graph
		ds.isGuidesEnabled = mxUtils.bind(this, function () {
			return this.editorUi.editor.graph.graphHandler.guidesEnabled;
		});
	}

	return elt;
};

/**
 * Adds the given stencil palette.
 */
Sidebar.prototype.destroy = function () {
	if (this.graph != null) {
		if (this.graph.container != null && this.graph.container.parentNode != null) {
			this.graph.container.parentNode.removeChild(this.graph.container);
		}

		this.graph.destroy();
		this.graph = null;
	}

	if (this.pointerUpHandler != null) {
		mxEvent.removeListener(document, mxClient.IS_POINTER ? 'pointerup' : 'mouseup', this.pointerUpHandler);
		this.pointerUpHandler = null;
	}

	if (this.pointerDownHandler != null) {
		mxEvent.removeListener(document, mxClient.IS_POINTER ? 'pointerdown' : 'mousedown', this.pointerDownHandler);
		this.pointerDownHandler = null;
	}

	if (this.pointerMoveHandler != null) {
		mxEvent.removeListener(document, mxClient.IS_POINTER ? 'pointermove' : 'mousemove', this.pointerMoveHandler);
		this.pointerMoveHandler = null;
	}

	if (this.pointerOutHandler != null) {
		mxEvent.removeListener(document, mxClient.IS_POINTER ? 'pointerout' : 'mouseout', this.pointerOutHandler);
		this.pointerOutHandler = null;
	}
};

Sidebar.prototype.ceeviewBasicStyle =
	'shape=image;' +
	'verticalLabelPosition=bottom;labelBackgroundColor=#ffffff;rounded=1;verticalAlign=top;' +
	'imageAspect=0;' +
	mxConstants.STYLE_SHADOW +
	'=1;' +
	mxConstants.STYLE_IMAGE_BACKGROUND +
	'=#c4c4c4;' +
	mxConstants.STYLE_IMAGE_CONTENT_TYPE +
	'=icon;' +
	mxConstants.STYLE_IMAGE_ICONS_PACK +
	'=glyphicons;' +
	mxConstants.STYLE_IMAGE_BORDER +
	'=#000000;';

Sidebar.prototype.ceeviewServiceElementStyle =
	Sidebar.prototype.ceeviewBasicStyle +
	'image=file;' +
	mxConstants.STYLE_IMAGE_PADDING +
	'=15;' +
	mxConstants.STYLE_IMAGE_FRAME +
	'=ellipse;';

Sidebar.prototype.defaultAssetIcon = 'heart';
Sidebar.prototype.ceeviewAssetStyle =
	Sidebar.prototype.ceeviewBasicStyle +
	'image=' +
	Sidebar.prototype.defaultAssetIcon +
	';' +
	mxConstants.STYLE_IMAGE_PADDING +
	'=15;' +
	mxConstants.STYLE_IMAGE_FRAME +
	'=ellipse;';

Sidebar.prototype.defaultAssetGroupIcon = 'folder-heart';
Sidebar.prototype.ceeviewAssetGroupStyle =
	Sidebar.prototype.ceeviewBasicStyle +
	'image=' +
	Sidebar.prototype.defaultAssetGroupIcon +
	';' +
	mxConstants.STYLE_IMAGE_PADDING +
	'=15;' +
	mxConstants.STYLE_IMAGE_FRAME +
	'=rect;';

Sidebar.prototype.ceeviewServiceLinkStyle =
	Sidebar.prototype.ceeviewBasicStyle + 'image=flowchart;' + mxConstants.STYLE_IMAGE_PADDING + '=5;';

Sidebar.prototype.ceeviewServiceRootStyle =
	Sidebar.prototype.ceeviewBasicStyle +
	'image=home;' +
	mxConstants.STYLE_IMAGE_PADDING +
	'=5;portConstraint=south;points=[[0.5,1]];';

Sidebar.prototype.ceeviewServiceModelStyle =
	Sidebar.prototype.ceeviewBasicStyle +
	'image=git-merge;' +
	mxConstants.STYLE_IMAGE_PADDING +
	'=5;portConstraint=south;points=[[0.5,1]];';

Sidebar.prototype.ceeviewStyles = {
	asset: Sidebar.prototype.ceeviewAssetStyle,
	assetGroup: Sidebar.prototype.ceeviewAssetGroupStyle,
};

Sidebar.prototype.ceeviewAssetUserObject = {
	datasource: {
		type: 'asset',
		showAsLabel: true,
	},
};

Sidebar.prototype.ceeviewAssetGroupUserObject = {
	datasource: {
		type: 'assetGroup',
		showAsLabel: true,
	},
	expanded: 'false',
};

//image=assets-static/designer/drawio/images/atlassian/Atlassian_Logo.svg;

// Adds Android shapes
Sidebar.prototype.addCeeviewPalette = function () {
	var doc = mxUtils.createXmlDocument();
	var healthIndexCellValue = doc.createElement('object');
	let healthIndexCellDatasource = {
		showHI: true,
		type: 'asset',
		showAsLabel: true,
	};

	healthIndexCellValue.setAttribute('healthIndexMode', 'true');
	healthIndexCellValue.setAttribute('label', '100');
	healthIndexCellValue.setAttribute('datasource', JSON.stringify(healthIndexCellDatasource));

	const assetCellValue = mxUtils.createUserObject(this.ceeviewAssetUserObject);
	const assetGroupCellValue = mxUtils.createUserObject(this.ceeviewAssetGroupUserObject);
	const serviceModelCell = mxUtils.createUserObject({ trigger: 'service-model' });

	var fns = [
		this.createVertexTemplateEntry(
			this.ceeviewServiceRootStyle,
			50,
			50,
			'',
			i18n('Service root node'),
			false,
			null,
			'ceeview service designer root',
		),

		this.createVertexTemplateEntry(
			this.ceeviewServiceElementStyle,
			50,
			50,
			'',
			i18n('Service element'),
			false,
			null,
			'ceeview service designer element',
		),

		this.createVertexTemplateEntry(
			this.ceeviewServiceLinkStyle,
			100,
			50,
			'',
			i18n('Linked'),
			false,
			null,
			'ceeview service designer linked',
		),

		this.createVertexTemplateEntry(
			'rounded=0;whiteSpace=wrap;html=1;fillColor=#c4c4c4;verticalLabelPosition=middle;verticalAlign=middle;labelPosition=center;align=center;fontSize=42;fontColor=#FFFFFF',
			120,
			60,
			healthIndexCellValue,
			i18n('Healthindex'),
			true,
			null,
			'ceeview service designer health index',
			null,
			true,
			'rounded=0;whiteSpace=wrap;html=1;fillColor=#c4c4c4;verticalLabelPosition=bottom;verticalAlign=top;',
		),

		this.createVertexTemplateEntry(
			this.ceeviewAssetStyle,
			50,
			50,
			assetCellValue,
			i18n('Ceeview standard shape'),
			false,
			null,
			'ceeview service designer asset',
		),

		this.createVertexTemplateEntry(
			this.ceeviewServiceModelStyle,
			50,
			50,
			serviceModelCell,
			i18n('Servicemodel'),
			false,
			null,
			'ceeview service designer assets group',
		),
	];

	this.addPaletteFunctions('ceeview', 'Ceeview', null, fns);
};
